import { Component, OnInit } from '@angular/core';
import { B2bComponent } from '../b2b.component';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'src/app/shared.service';
import { ManagementServiceService } from 'src/app/management-service.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Subject } from 'rxjs';
import { debounceTime, finalize, distinctUntilChanged  } from 'rxjs/operators';
import { B2BService } from 'src/app/b2-b.service';
import { HostListener } from '@angular/core'; // make sure this is imported
import { 
  ColDef, 
  GridApi, 
  ColumnApi, 
  PasteStartEvent, 
  PasteEndEvent 
} from 'ag-grid-community';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { initializeCartLocal } from 'src/app/utils/cart-initializer.util';

@Component({
  selector: 'app-list-prices-ag-grid',
  templateUrl: './list-prices-ag-grid.component.html',
  styleUrls: ['./list-prices-ag-grid.component.css']
})
export class ListPricesAgGridComponent implements OnInit {

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    if (this.gridApi) {
      this.gridApi.resetRowHeights(); // Optional if height changes
      this.gridApi.sizeColumnsToFit(); // Resize columns to fit available space
    }
  }

  constructor(public parent: B2bComponent, private managementService:ManagementServiceService, private B2BService:B2BService, private service:SharedService, private cookieService: CookieService, public translate: TranslateService, private router:Router, private _bottomSheet: MatBottomSheet,  private route: ActivatedRoute) {
    translate.addLangs(['en', 'ro', 'de', 'es', 'fr', 'it', 'pl', 'pt']);
    translate.setDefaultLang('en');

    const browserLang = this.parent.getLanguage();
    translate.use(browserLang.match(/en|ro|de|es|fr|it|pl|pt/) ? browserLang : 'en');

    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };

    // Debounce search.
    this.brandSearchTermUpdate.pipe(
      debounceTime(500),
      distinctUntilChanged())
      .subscribe(value => {
        this.BrandFilter.SearchTerm = value;

        if(this.BrandFilter.SearchTerm?.length > 2){
          this.GetBrandsFilteredWithSuggestion(value, 1, null);
        }
      });

    // Debounce search for Detected Product Popup brand search
    this.detectedProductBrandSearchUpdate.pipe(
      debounceTime(400),
      distinctUntilChanged())
      .subscribe(value => {
        this.DetectedProductBrandSearchTerm = value;
        this.SearchBrandsForDetectedProductPopup(value);
      });

  }

  searchTermUpdate = new Subject<string>();

  private pastedLineCount: number = 0;
  private pastedRows: { rowIndex: number; name: string; quantity: any }[] = [];
  private pasteSubject = new Subject<void>();

  private readonly MAX_PASTE_ROWS = 150;
  private allowedPastedRowIndices: Set<number> = new Set();

  private pendingSearchRequests: number = 0;
  private pasteBatchInProgress: boolean = false;

  private pendingPasteRowIndexes: Set<number> = new Set();
  private pasteSyncTimer: any = null;

  namePlaceholder: string = '';
  specialPriceCellTranslation: string = '';
  MOQAdjustmentTooltip: string = '';
  brandSearchTermUpdate = new Subject<string>();
  CurrentCartItemRow:any;
  Language:any;

  // Tab state: 'pricing' (default) | 'terms'
  activeSearchTab: string = 'pricing';

  AskAddNewRFQQuestion:boolean = false;
  selectedAgents: any[] = [];
  agentOrderPhases: any[] = [];

  // ✅ Stock Readjusted Popup
  showStockReadjustedPopup: boolean = false;
  stockReadjustedMessage: string = '';
  stockReadjustedProducts: string[] = [];

  // ✅ Detected Product Popup (for invalid items - CartItemStatus.ID === 0)
  ShowDetectedProductPopup: boolean = false;
  DetectedProductData: any = null;
  LoadingDetectedProduct: boolean = false;
  DetectedProductRowIndex: number = -1;
  DetectedProductSearchTerm: string = '';

  // ✅ Detected Product Popup - Brand Search
  DetectedProductBrandSearchTerm: string = '';
  DetectedProductBrandsList: any[] = [];
  DetectedProductBrandsLoading: boolean = false;
  DetectedProductShowBrandDropdown: boolean = false;
  detectedProductBrandSearchUpdate = new Subject<string>();

  // ✅ Ask Price & Delivery flow state
  LoadingAskPriceDelivery: boolean = false;
  AskPriceDeliveryError: string = '';
  AskPriceDeliverySuccess: boolean = false;

  // ✅ Offer Request Master Data (contains OrderConsolidationTypes, OrderDeliveryPreferences)
  OfferRequestMasterData: {[k: string]: any} = {};

  // ✅ SendEmailSearchBar dropdown toggle flags
  showDeliveryPreferenceDropdown: boolean = false;
  showShippingAddressDropdown: boolean = false;
  showConsolidationTypeDropdown: boolean = false;
  showShippingCompanyDropdown: boolean = false;
  showShippingResponsabilityDropdown: boolean = false;
  showShippingServiceTypeDropdown: boolean = false;
  showAgentsDropdown: boolean = false;

  // ✅ Mandatory Address Completion Modal
  showMandatoryAddressModal: boolean = false;
  mandatoryAddressEdit: any = null;

  // ✅ Shipping logistics properties
  ShippingCompanies: any[] = [];
  ShippingResponsabilities: any[] = [];
  ShippingServiceTypes: any[] = [];
  loadingShippingOptions: boolean = false;

  // ✅ Wizard step tracking for PO and RFQ popups
  currentPOStep: number = 1;
  currentRFQStep: number = 1;

  // ✅ Wizard navigation methods
  goToPOStep(step: number): void {
    if (step >= 1 && step <= 3) {
      this.currentPOStep = step;
      this.closeAllPopupDropdowns();
    }
  }

  goToRFQStep(step: number): void {
    if (step >= 1 && step <= 3) {
      this.currentRFQStep = step;
      this.closeAllPopupDropdowns();
    }
  }

  nextPOStep(): void {
    if (this.currentPOStep < 3) {
      this.currentPOStep++;
      this.closeAllPopupDropdowns();
    }
  }

  prevPOStep(): void {
    if (this.currentPOStep > 1) {
      this.currentPOStep--;
      this.closeAllPopupDropdowns();
    }
  }

  nextRFQStep(): void {
    if (this.currentRFQStep < 3) {
      this.currentRFQStep++;
      this.closeAllPopupDropdowns();
    }
  }

  prevRFQStep(): void {
    if (this.currentRFQStep > 1) {
      this.currentRFQStep--;
      this.closeAllPopupDropdowns();
    }
  }

  resetPOWizard(): void {
    this.currentPOStep = 1;
    this.AskAddNewRFQasPOQuestion = false;
  }

  resetRFQWizard(): void {
    this.currentRFQStep = 1;
    this.AskAddNewRFQQuestion = false;
  }

  // ✅ Get selected agents as comma-separated string for summary
  getSelectedAgentsSummary(): string {
    if (!this.selectedAgents || this.selectedAgents.length === 0) {
      return '-';
    }
    return this.selectedAgents.map(a => a.Name).join(', ');
  }

  // ✅ Get valid cart items for wizard review table
  getValidCartItems(): any[] {
    return this.parent.Cart?.Items?.filter((i: any) => i?.CartItemStatus?.ID === 1) || [];
  }

  // ✅ Get cart items count for summary
  getCartItemsCount(): number {
    return this.getValidCartItems().length || 0;
  }

  // ✅ Wizard delete confirmation state
  wizardDeleteConfirmUIID: string | null = null;
  wizardDeleteConfirmProductName: string = '';

  // ✅ Ask for delete confirmation in wizard Step 3
  askRemoveCartItemFromWizard(item: any): void {
    this.wizardDeleteConfirmUIID = item?.UIID || null;
    this.wizardDeleteConfirmProductName = item?.Product?.Brand?.Name
      ? `${item.Product.Brand.Name} - ${item.Product?.Name || item.Product?.PartNumber || ''}`
      : (item?.Product?.Name || item?.Product?.PartNumber || '');
  }

  // ✅ Cancel wizard delete
  cancelWizardDelete(): void {
    this.wizardDeleteConfirmUIID = null;
    this.wizardDeleteConfirmProductName = '';
  }

  // ✅ Confirm and remove cart item from wizard
  confirmWizardDelete(): void {
    const uiid = this.wizardDeleteConfirmUIID;
    this.wizardDeleteConfirmUIID = null;
    this.wizardDeleteConfirmProductName = '';

    if (!uiid || !this.parent.Cart?.Items) return;

    // Find the grid row index matching this UIID
    let gridRowIndex = -1;
    this.gridApi?.forEachNode((node: any) => {
      if (node?.data?.CartItem?.UIID === uiid) {
        gridRowIndex = node.rowIndex;
      }
    });

    // Remove from grid
    if (gridRowIndex >= 0) {
      this.deleteRow(gridRowIndex);
    }
  }

  // ✅ Get cart total for summary
  getCartTotal(): string {
    const total = this.parent.Cart?.Total?.TotalQtyPriceNOVAT;
    const currency = this.parent.Cart?.Currency?.Symbol || this.parent.Cart?.Currency?.Name || '';
    if (total != null) {
      return `${Number(total).toFixed(2)} ${currency}`;
    }
    return '-';
  }

  // ✅ Get PO obligation disclaimer with embedded verified icon
  getPOObligationDisclaimer(translatedText: string): string {
    const verifiedIcon = '<i class="material-icons trusted-icon" style="color: #32aa3a; font-size: 16px; vertical-align: middle; cursor: help;">verified</i>';
    return translatedText.replace('(✓)', verifiedIcon);
  }

  // ✅ Close all popup dropdowns
  closeAllPopupDropdowns(): void {
    this.showDeliveryPreferenceDropdown = false;
    this.showShippingAddressDropdown = false;
    this.showConsolidationTypeDropdown = false;
    this.showShippingCompanyDropdown = false;
    this.showShippingResponsabilityDropdown = false;
    this.showShippingServiceTypeDropdown = false;
    this.showAgentsDropdown = false;
  }

  // ✅ Select Delivery Preference
  selectDeliveryPreference(item: any): void {
    this.parent.Cart.DeliveryPreference = item;
    this.showDeliveryPreferenceDropdown = false;
  }

  // ✅ Select Shipping Address
  selectShippingAddress(item: any): void {
    this.parent.OfferRequest.ShippingAddress = item;
    // ✅ Always update IsSelected on the source B2BPartner.ShippingAddresses (master list)
    if (this.parent.B2BPartner?.ShippingAddresses) {
      this.parent.B2BPartner.ShippingAddresses.forEach((a: any) => {
        a.IsSelected = a.ID === item.ID;
      });
    }
    // Update IsSelected flags on OfferRequest.Cart.Partner.ShippingAddresses
    if (this.parent.OfferRequest?.Cart?.Partner?.ShippingAddresses) {
      this.parent.OfferRequest.Cart.Partner.ShippingAddresses.forEach((a: any) => {
        a.IsSelected = a.ID === item.ID;
      });
    }
    this.showShippingAddressDropdown = false;

    // ✅ Validate the selected address - open mandatory modal if incomplete
    this.checkAndOpenMandatoryAddressModal();
  }

  // ✅ Validate shipping address completeness
  isShippingAddressValid(addr: any): boolean {
    if (!addr) return false;
    return !!(
      addr.ContactPerson?.trim() &&
      addr.Country?.ID &&
      addr.City?.trim() &&
      addr.AddressLine?.trim() &&
      addr.ZipCode?.trim() &&
      addr.State?.trim() &&
      addr.Phone?.trim() &&
      addr.Email?.trim()
    );
  }

  // ✅ Check current shipping address and open mandatory modal if incomplete
  checkAndOpenMandatoryAddressModal(): void {
    const addr = this.parent.OfferRequest?.ShippingAddress;
    if (addr && !this.isShippingAddressValid(addr)) {
      this.mandatoryAddressEdit = JSON.parse(JSON.stringify(addr));
      this.showMandatoryAddressModal = true;
      this.showMandatoryAddressCountryDropdown = false;
    }
  }

  // ✅ Mandatory Address modal - Country dropdown
  showMandatoryAddressCountryDropdown: boolean = false;
  mandatoryAddressCountries: any[] = [];

  getMandatoryAddressCountries(searchTerm: string = ''): void {
    const allCountries = this.parent.masterData?.Countries || [];
    if (searchTerm && searchTerm.length > 0) {
      this.mandatoryAddressCountries = allCountries.filter((c: any) =>
        c.Name?.toLowerCase().startsWith(searchTerm.toLowerCase())
      );
    } else {
      this.mandatoryAddressCountries = [...allCountries];
    }
  }

  selectMandatoryAddressCountry(country: any): void {
    if (this.mandatoryAddressEdit) {
      this.mandatoryAddressEdit.Country = country;
    }
    this.showMandatoryAddressCountryDropdown = false;
  }

  // ✅ Save mandatory address and persist to backend
  saveMandatoryAddress(): void {
    if (!this.mandatoryAddressEdit || !this.isShippingAddressValid(this.mandatoryAddressEdit)) return;

    var request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      ShippingAddress: this.mandatoryAddressEdit,
      PartnerID: this.parent.B2BPartner.ID
    };

    this.parent.loading = true;

    this.service.AddUpdateShippingAddress(request).subscribe(response => {
      this.parent.loading = false;

      if (response["Status"] != 1) {
        this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        return;
      }

      var savedAddress = response["ShippingAddress"];

      // Update the OfferRequest.ShippingAddress with the backend-confirmed data
      this.parent.OfferRequest.ShippingAddress = savedAddress;

      // Synchronize the address in the master list
      if (this.parent.B2BPartner?.ShippingAddresses) {
        var idx = this.parent.B2BPartner.ShippingAddresses.findIndex((a: any) => a.ID === savedAddress.ID);
        if (idx >= 0) {
          this.parent.B2BPartner.ShippingAddresses[idx] = savedAddress;
        }
      }

      // Only close modal after successful save
      this.showMandatoryAddressModal = false;
      this.mandatoryAddressEdit = null;
    }, (error: any) => {
      this.parent.loading = false;
      console.error('Error saving mandatory shipping address:', error);
      this.parent.openSnackBar('Error saving address. Please try again.', "OK", "alert-info-snackbar");
    });
  }

  // ✅ Select Consolidation Type
  selectConsolidationType(item: any): void {
    this.parent.OfferRequest.ConsolidationType = item;
    this.showConsolidationTypeDropdown = false;
  }

  // ✅ Select Shipping Company
  selectShippingCompany(company: any): void {
    this.parent.Cart.ShippingCompany = JSON.parse(JSON.stringify(company));
    this.showShippingCompanyDropdown = false;
  }

  // ✅ Select Shipping Responsibility
  selectShippingResponsability(item: any): void {
    this.parent.Cart.ShippingResponsability = JSON.parse(JSON.stringify(item));
    this.showShippingResponsabilityDropdown = false;
  }

  // ✅ Select Shipping Service Type
  selectShippingServiceType(item: any): void {
    this.parent.Cart.ShippingServiceType = JSON.parse(JSON.stringify(item));
    this.showShippingServiceTypeDropdown = false;
  }

  // ✅ Get Shipping Master Data (Responsibilities, Service Types)
  GetShippingMasterData(): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage()
    };

    this.managementService.GetShippingMasterData(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingResponsabilities = response["ShippingResponsabilities"] || [];
        this.ShippingServiceTypes = response["ShippingServiceTypes"] || [];
      }
    });
  }

  // ✅ Get Country-specific Shipping Options (shipping companies available for the destination country)
  GetCountryShippingOptions(): void {
    const country = this.parent.OfferRequest?.ShippingAddress?.Country
      || this.parent.B2BPartner?.BillingAddress?.Country;

    if (!country?.ID) {
      return;
    }

    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      Country: country,
      PartnerID: this.parent.B2BPartner?.ID,
      DirectionID: 1
    };

    this.loadingShippingOptions = true;

    this.managementService.GetCountryShippingOptions(request).subscribe(response => {
      if (response["Status"] == 1) {
        this.ShippingCompanies = response["ShippingCompanies"] || [];

        // Auto-select first or previously selected company
        if (this.ShippingCompanies.some(x => x.IsSelected == true)) {
          this.selectShippingCompany(this.ShippingCompanies.filter(x => x.IsSelected == true)[0]);
        } else if (this.ShippingCompanies.length > 0) {
          this.selectShippingCompany(this.ShippingCompanies[0]);
        }
      }
      this.loadingShippingOptions = false;
    });
  }

  // ✅ Helper method to check if agent is selected
  isAgentSelected(agent: any): boolean {
    return this.selectedAgents?.some(a => a.ID === agent.ID) || false;
  }

  // ✅ Toggle agent selection for ModernCheckboxGroup
  toggleAgentSelection(agent: any): void {
    if (!this.selectedAgents) {
      this.selectedAgents = [];
    }
    const index = this.selectedAgents.findIndex(a => a.ID === agent.ID);
    if (index >= 0) {
      this.selectedAgents.splice(index, 1);
    } else {
      this.selectedAgents.push(agent);
    }

    // ✅ Sync IsSelected on the actual B2BPartner.PartnerAgents so the backend receives correct flags
    if (this.parent.B2BPartner?.PartnerAgents) {
      const actualAgent = this.parent.B2BPartner.PartnerAgents.find((a: any) => a.ID === agent.ID);
      if (actualAgent) {
        actualAgent.IsSelected = (index < 0); // was added (index < 0) → true, was removed (index >= 0) → false
      }
    }
  }

  // ✅ Agent Order Phases methods
  showB2BAgentPhasesPopup: boolean = false;
  selectedB2BPhaseAgent: any = null;
  selectedB2BPhaseIDs: number[] = [];

  loadAgentOrderPhases(): void {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage()
    };
    this.service.GetPartnersMasterData(request).subscribe((response: any) => {
      if (response.Status === 1) {
        this.agentOrderPhases = response.PartnerAgentOrderPhases || [];
      }
    });
  }

  openB2BAgentPhasesPopup(agent: any): void {
    this.selectedB2BPhaseAgent = agent;
    this.selectedB2BPhaseIDs = (agent.OrderPhases || []).map((p: any) => p.ID);
    this.showB2BAgentPhasesPopup = true;
  }

  closeB2BAgentPhasesPopup(): void {
    this.showB2BAgentPhasesPopup = false;
    this.selectedB2BPhaseAgent = null;
    this.selectedB2BPhaseIDs = [];
  }

  isPhaseSelectedInPopup(phase: any): boolean {
    return this.selectedB2BPhaseIDs.includes(phase.ID);
  }

  togglePhaseInPopup(phase: any): void {
    const idx = this.selectedB2BPhaseIDs.indexOf(phase.ID);
    if (idx >= 0) {
      this.selectedB2BPhaseIDs.splice(idx, 1);
    } else {
      this.selectedB2BPhaseIDs.push(phase.ID);
    }
  }

  saveB2BAgentPhases(): void {
    if (!this.selectedB2BPhaseAgent) return;

    const agentID = this.selectedB2BPhaseAgent.ID;

    // Save as default phases for this agent
    if (agentID > 0) {
      const request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        AgentID: agentID,
        PhaseIDs: this.selectedB2BPhaseIDs
      };
      this.service.AddUpdatePartnerAgentDefaultPhases(request).subscribe((response: any) => {
        if (response.Status === 1 && response.Phases?.length > 0) {
          this.selectedB2BPhaseAgent.OrderPhases = response.Phases;
        } else {
          // Fallback: update locally from masterdata
          this.selectedB2BPhaseAgent.OrderPhases = this.selectedB2BPhaseIDs.map((id: number) => {
            const masterPhase = this.agentOrderPhases.find((p: any) => p.ID === id);
            return masterPhase ? JSON.parse(JSON.stringify(masterPhase)) : { ID: id, Name: '', Description: '' };
          });
        }
      });
    } else {
      // Agent not yet saved — update locally only
      this.selectedB2BPhaseAgent.OrderPhases = this.selectedB2BPhaseIDs.map((id: number) => {
        const masterPhase = this.agentOrderPhases.find((p: any) => p.ID === id);
        return masterPhase ? JSON.parse(JSON.stringify(masterPhase)) : { ID: id, Name: '', Description: '' };
      });
    }

    this.closeB2BAgentPhasesPopup();
  }

  OpenAskAddNewRFQQuestion(){
    // this.OfferRequest.DebatorPO = "";
    this.currentRFQStep = 1; // ✅ Reset wizard to step 1
    this.AskAddNewRFQQuestion = true;
    this.InitializeCart();
    this.InitializeAgentsAndShippingAddress();
  }

  AskAddNewRFQasPOQuestion:boolean = false;

  OpenAskAddNewRFQasPOQuestion(){
    // this.OfferRequest.DebatorPO = "";
    this.currentPOStep = 1; // ✅ Reset wizard to step 1
    this.AskAddNewRFQasPOQuestion = true;
    this.InitializeCart();
    this.InitializeAgentsAndShippingAddress();
    this.GetShippingMasterData();
    this.GetCountryShippingOptions();
  }
  
  async AddNewOffer(POButtonPressed: boolean = false, cart: any = null, jumpOverDuplicateVerification: boolean = false) {
    if (this.parent.loading !== true) {
      // ✅ Snapshot shipping selections before deep-copy wipes them
      var snapshotShippingCompany = this.parent.Cart?.ShippingCompany || null;
      var snapshotShippingResponsability = this.parent.Cart?.ShippingResponsability || null;
      var snapshotShippingServiceType = this.parent.Cart?.ShippingServiceType || null;

      // Get cart from parent if not provided
      if (!cart) {
        this.parent.GetCart();
      } else {
        this.parent.Cart = JSON.parse(JSON.stringify(cart));
      }

      // Prepare OfferRequest from parent
      this.parent.OfferRequest.UserUploader = this.parent.User;
      this.parent.OfferRequest.AgentManager = this.parent.B2BAgent;
      this.parent.OfferRequest.Company = this.parent.Company;
      this.parent.OfferRequest.Cart = this.parent.Cart;
      // ✅ Ensure Cart.Partner has the B2BPartner with updated ShippingAddresses (including IsSelected flags)
      this.parent.OfferRequest.Cart.Partner = this.parent.B2BPartner;
      this.parent.OfferRequest.Type = this.parent.CartMasterData.OrderTypes?.find((x: any) => x.ID === 4);
      this.parent.OfferRequest.PaymentType = this.parent.Cart.PaymentType;
      this.parent.OfferRequest.DeliveryPreference = this.parent.Cart.DeliveryPreference;
      this.parent.OfferRequest.ConsolidationType = this.parent.OfferRequest.ConsolidationType;

      // ✅ Re-apply shipping selections after deep-copy
      this.parent.OfferRequest.Cart.ShippingCompany = snapshotShippingCompany;
      this.parent.OfferRequest.Cart.ShippingResponsability = snapshotShippingResponsability;
      this.parent.OfferRequest.Cart.ShippingServiceType = snapshotShippingServiceType;

      var request = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        OfferRequest: this.parent.OfferRequest,
        POButtonPressed: POButtonPressed,
        SendEmail: true,
        JumpOverDuplicateVerification: jumpOverDuplicateVerification
      };

      this.parent.loading = true;

      // ✅ Call the new combined endpoint that creates OfferRequest + OrderConfirmation
      this.managementService.AddOfferRequestWithOrderConfirmation(request).subscribe(response => {
        if (response["Status"] == -3) {
          // ✅ Duplicate order detected - show popup with existing order details
          this.parent.DuplicateOfferRequest = response["OfferRequest"];
          this.parent.ShowDuplicateOrderPopup = true;
          this.parent.loading = false;
        } else if (response["Status"] != 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
          this.parent.loading = false;
        } else if (response["Status"] == 1) {
          // ✅ Success - both OfferRequest and OrderConfirmation created
          var OfferRequest = response["OfferRequest"];
          var OrderConfirmation = response["OrderConfirmation"];
          localStorage.removeItem("Cart");
          // Navigate to the OfferRequest confirmation page (same as before)
          this.parent.GoToRequestOfferConfirmation(OfferRequest.ID);
          this.parent.loading = false;
        }
      });
    }
  }
  columnDefs = [
    {
      headerName: '#',
      field: 'index',
      valueGetter: 'node.rowIndex + 1',
      editable: false,
      minWidth: 25,
      flex: 0.5,
      suppressSizeToFit: true,
      suppressMenu: true
    },
    {
      headerName: 'Brand',
      field: 'brand',
      editable: false,
      minWidth: 125,
      flex: 0.75,
      suppressMenu: true,
      cellRenderer: this.BrandCellRenderer.bind(this),
      cellClassRules: {
        'GridAwaitingSelection': (p: any) => p.data?.CartItem?.CartItemStatus?.ID === -1
      }
    },
    {
      headerName: 'PartNumber',
      field: 'partNumber',
      editable: false,
      minWidth: 100,
      flex: 1,
      suppressMenu: true
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: true,
      minWidth: 250,
      flex: 14,
      suppressMenu: true,
      cellRenderer: this.NameCellRenderer.bind(this),
      cellClassRules: {
       'GridAwaitingSelection': (p: any) => p.data?.CartItem?.CartItemStatus?.ID === -1
      }
    },
    {
      headerName: 'Qty',
      field: 'quantity',
      editable: true,
      type: 'numericColumn',
      valueParser: this.numberParser,
      minWidth: 60,
      flex: 0.75,
      suppressMenu: true,
      cellClassRules: {
        'quantity-modified': (params: any) =>
          params.data?.CartItem?.SelectedOffer?.ChangedQunatityFromMOQ === true
      },
      tooltipValueGetter: function (params) {
        const selectedOffer = params.data?.CartItem?.SelectedOffer;
        // Show MOQ adjustment tooltip if applicable
        if (selectedOffer?.ChangedQunatityFromMOQ) {
          return params.context.componentParent.MOQAdjustmentTooltip;
        }
        // Show stock quantity tooltip if StockQuantity > 0 and NOT a manufacturer stock offer
        if (selectedOffer?.StockQuantity > 0 && selectedOffer?.IsManufacturerStockOffer !== true) {
          return `Stock: ${selectedOffer.StockQuantity}`;
        }
        return null;
      },
      tooltipComponentParams: {
        class: 'custom-moq-tooltip'
      }
    },
    {
      headerName: 'List-Price', // ✅ Updated dynamically via updateColumnHeaders()
      field: 'officialListPrice',
      editable: false,
      minWidth: 90,
      flex: 2,
      suppressMenu: true,
      cellRenderer: (p: any) => this.officialListPriceCellRenderer(p),
      cellClass: 'listprice-cell'
    },
    {
      headerName: 'Discount',
      field: 'officialDiscount',
      editable: false,
      minWidth: 75,
      flex: 0.75,
      suppressMenu: true,
      type: 'rightAligned',
      cellRenderer: (p: any) => this.officialDiscountCellRenderer(p)
    },
    {
      headerName: 'Final-Price', // ✅ Updated dynamically via updateColumnHeaders()
      field: 'price',
      editable: false,
      minWidth: 100,
      flex: 2,
      suppressMenu: true,
      cellRenderer: this.priceCellRenderer.bind(this),
      cellClass: 'yourprice-cell'
    },
    {
      headerName: 'Total', // ✅ Updated dynamically via updateColumnHeaders()
      field: 'total',
      editable: false,
      minWidth: 90,
      flex: 2,
      suppressMenu: true,
      cellClass: 'yourprice-cell'
    },
    {
      headerName: 'Standard-Delivery',
      field: 'eta',
      editable: false,
      minWidth: 140,
      flex: 2,
      suppressMenu: true,
      cellRenderer: this.ETACellRenderer.bind(this),
      tooltipValueGetter: (params: any) => {
        const cartItem = params.data?.CartItem;
        const isTrusted = cartItem?.Product?.Stats?.TrustedManufacturerLeadTime === true;
        if (!isTrusted) return null;

        const manufacturerStock = cartItem?.Product?.Stats?.ManufacturerStock;

        const stockText = manufacturerStock != null ? manufacturerStock : '-';

        return `Manufacturer stock: ${stockText}\nTrusted information`;
      },
      tooltipComponentParams: {
        class: 'trusted-tooltip'
      }
    },
    {
      headerName: 'HSCode',
      field: 'hscode',
      editable: false,
      minWidth: 100,
      flex: 0.75,
      suppressMenu: true
    },
    {
      headerName: 'COO',
      field: 'coo',
      editable: false,
      minWidth: 75,
      flex: 0.75,
      suppressMenu: true
    },
    {
      headerName: 'Weight',
      field: 'weight',
      editable: false,
      minWidth: 75,
      flex: 0.75,
      suppressMenu: true
    },
    // 🔵 NEW: PDF icon column (header shows icon; rows show light-blue icon only if DatasheetLink exists)
    {
      headerName: '',
      field: 'datasheet',
      minWidth: 50,
      flex: 1,
      suppressMenu: true,
      suppressSorting: true,
      editable: false,
      suppressSizeToFit: true,
      headerComponentParams: {
        template: `
          <div class="ag-cell-label-container" role="presentation" style="justify-content:center;">
            <span class="ag-header-cell-text">
              <i class="material-icons pdf-header-icon" title="Datasheet" style="font-size:17px;">file_present</i>
            </span>
          </div>
        `
      },
      cellRenderer: (p: any) => {
        const link = p?.data?.CartItem?.Product?.Stats?.DatasheetLink;
        const hasLink = typeof link === 'string' && link.trim().length > 0;
        if (!hasLink) return ''; // no button if no link

        // escape quotes to avoid breaking the attribute
        const safeHref = String(link).replace(/"/g, '&quot;');

        return `
          <button
            class="pdf-datasheet-button material-icon-trigger"
            data-row="${p.rowIndex}"
            data-href="${safeHref}"
            title="Open datasheet"
            aria-label="Open datasheet">
            <i class="material-icons pdf-cell-icon" style="font-size:17px;margin-right:7px;">file_present</i>
          </button>
        `;
      }
    },
    {
      headerName: '',
      field: 'delete',
      minWidth: 35,
      flex: 1,
      suppressMenu: true,
      suppressSorting: true,
      editable: false,
      suppressSizeToFit: true,
      cellRenderer: () => {
        return `<button class="delete-row-button material-icon-trigger" title="Delete row">
                  <i class="material-icons">close</i>
                </button>`;
      }
    }
  ];

  rowData: any[] = [];
  defaultColDef = {
    resizable: true,
    // sortable: true,
    // filter: true,
    flex: 1,
    minWidth: 100,
    cellClass: (params: any) => {
      return params.colDef.field === 'name' ? 'cell-white' : 'cell-gray';
    }
  };

  gridOptions = {
    rowHeight: 30,
    headerHeight: 30,
    enableRangeSelection: true,
    suppressClipboardApi: true,
    enableFillHandle: true,
    enableClipboard:true,
    suppressClipboardPaste: false,
    suppressLastEmptyLineOnPaste: true,
    rowSelection: 'multiple',
    suppressRowClickSelection: true,
    stopEditingWhenCellsLoseFocus: true,
    singleClickEdit: false,
    undoRedoCellEditing: true,
    tooltipShowDelay: 0,      // Show immediately (instant)
    tooltipHideDelay: 0,      // Hide immediately when cursor leaves (instant)
    enableBrowserTooltips: false, // Use AG Grid tooltips, not browser default
    context: {
      componentParent: this
    },
    undoRedoCellEditingLimit: 20,
    domLayout: 'autoHeight',
    getContextMenuItems: (params: any) => {
      const cellRanges = params.api.getCellRanges();
      const hasSelection = cellRanges && cellRanges.length > 0;

      const menuItems: any[] = [
        {
          name: 'Paste',
          action: () => {
            this.triggerPasteFromContextMenu(params);
          },
          icon: '<i class="material-icons" style="font-size: 16px;">content_paste</i>',
          shortcut: 'Ctrl+V'
        },
        'separator',
        'copy',
        'copyWithHeaders',
        'separator'
      ];

      // Add delete option if there's a selection
      if (hasSelection) {
        menuItems.push({
          name: 'Delete Selected Rows',
          action: () => {
            this.deleteSelectedRows(cellRanges);
          },
          icon: '<i class="material-icons" style="font-size: 16px; color: #f44336;">delete</i>',
          shortcut: 'Delete'
        });
        menuItems.push('separator');
      }

      menuItems.push('export');

      return menuItems;
    },
    /** <-- replace getRowClass with this */
    rowClassRules: {
      // GridAwaitingSelection: p => p.data?.CartItem?.CartItemStatus?.ID === -1,
      GridNotValid:         p => p.data?.CartItem?.CartItemStatus?.ID === 0,
      GridValid:            p => {
        const isStock = p.data?.CartItem?.SelectedOffer?.IsStockOffer === true;
        const hasQty = p.data?.CartItem?.SelectedOffer?.StockQuantity > 0;
        const isNotMfgStock = p.data?.CartItem?.SelectedOffer?.IsManufacturerStockOffer !== true;
        return isStock && hasQty && isNotMfgStock;
      },
    },
    onGridReady: (params: any) => params.api.sizeColumnsToFit(),
    onCellValueChanged: (event: any) => this.onCellValueChanged(event),
    onPasteEnd: (params: any) => this.handlePaste(params),
    getRowClass: (params: any) => {
      const CartItem = params.data?.CartItem;
      if (!CartItem) return null;
  
      return null; // No class
    },
    suppressKeyboardEvent: (params) => {
      const e = params.event as KeyboardEvent;

      // Helper: are we currently editing inside an input-like element?
      const tgt = e.target as HTMLElement | null;
      const isInputish =
        params.editing ||
        (tgt &&
          (tgt.tagName === 'INPUT' ||
           tgt.tagName === 'TEXTAREA' ||
           (tgt as any).isContentEditable === true));

      const isPaste =
        (e.ctrlKey || e.metaKey) && (e.key?.toLowerCase() === 'v' || e.code === 'KeyV');

      if (isPaste) {
        // ✅ Mark as Ctrl+V paste (keyboard paste)
        this.isPasting = true;
        this.pasteEventType = 2; // eB2BUserTrackingEventType.CopyPasteKeyBoard

        if (!isInputish) {
          // Not inside an editor: commit any edit, then let AG Grid handle multi-cell paste
          params.api.stopEditing();
          return false; // allow paste to proceed to the grid
        }
        // Inside an editor: let the browser paste into the input
        return false; // don't block it
      }

      // Handle DELETE key for selected rows
      const isDelete = e.key === 'Delete' || e.key === 'Backspace';
      if (isDelete && !isInputish) {
        // Get selected cell ranges
        const cellRanges = params.api.getCellRanges();
        if (cellRanges && cellRanges.length > 0) {
          this.deleteSelectedRows(cellRanges);
          return true; // suppress the default delete behavior
        }
      }

      // Let everything else behave normally
      return false;
    },
    onPasteStart: (params) => {
      console.log('🔍 onPasteStart triggered', params);
    },
    tabToNextCell: (params) => {
      const { previousCellPosition } = params;
      if (!previousCellPosition) return null;
  
      const colId = previousCellPosition.column.getColId();
      const rowIndex = previousCellPosition.rowIndex;
  
      // If we're in the 'name' column, Tab goes DOWN in same col
      if (colId === 'name') {
        return {
          rowIndex: rowIndex + 1,
          column: previousCellPosition.column,
          rowPinned: previousCellPosition.rowPinned
        };
      }
  
      // If we're in the 'quantity' column, Tab goes DOWN in same col
      if (colId === 'quantity') {
        return {
          rowIndex: rowIndex + 1,
          column: previousCellPosition.column,
          rowPinned: previousCellPosition.rowPinned
        };
      }
  
      // Otherwise, fallback to AG Grid default
      return null;
    },
    navigateToNextCell: (params) => {
      const { previousCellPosition, key } = params;
      if (!previousCellPosition) return null;
  
      const colId = previousCellPosition.column.getColId();
      const rowIndex = previousCellPosition.rowIndex;
  
      // Handle Enter key only for 'quantity' column
      if (key === 'ArrowDown' || key === 'Enter') {
        if (colId === 'quantity') {
          return {
            rowIndex: rowIndex + 1,
            column: previousCellPosition.column,
            rowPinned: previousCellPosition.rowPinned
          };
        }
      }
  
      // Fallback to default
      return null;
    }
  };
  
  private gridApi!: GridApi;
  private columnApi!: ColumnApi;

  priceCellRenderer(params: any): string {
    const price = params.value ?? '';
    const cartItem = params.data?.CartItem;
    const translate = params.context?.translate;
    const rowIndex = params.rowIndex;

    // ✅ Check for invalid item (CartItemStatus.ID === 0) - show Ask-Price button
    if (cartItem?.CartItemStatus?.ID === 0) {
      const searchTerm = cartItem?.UIProductValue ?? '';
      return `
        <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%;">
          <button class="dropdown-trigger"
                  style="display: flex; align-items: center; justify-content: center; width: 26px; height: 26px; border: none; border-radius: 50%; background: linear-gradient(135deg, #32aa3a 0%, #28a745 100%); color: #ffffff; cursor: pointer; box-shadow: 0 2px 6px rgba(40, 167, 69, 0.35);"
                  data-row="${rowIndex}"
                  data-type="askPrice"
                  data-search="${searchTerm}"
                  title="Ask for price and delivery">
            <i class="material-icons" style="font-size: 16px; color: #ffffff;">arrow_forward</i>
          </button>
        </div>
      `;
    }

    let showTriangle = false;
    let tooltipText = '';
    let priceClass = '';

    // Check for MOQ-based special offer
    let moq = null;
    if (Array.isArray(cartItem?.SearchResults)) {
      const special = cartItem.SearchResults.find((x: any) => x.SpecialOffer === true && x.MOQ > 1 && x.FKBrandID == cartItem?.Product?.Brand?.ID);
      if (special) {
        if(special?.Price?.UIUnitPrice < cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice){
          moq = special?.MOQ ?? 0;
          showTriangle = true;

          const unitPrice = special?.Price?.UIUnitPrice;
          const currencyName = special?.Price?.Currency?.Symbol ?? special?.Price?.Currency?.Name ?? '';
          const priceStr = typeof unitPrice === 'number' && isFinite(unitPrice) ? unitPrice.toFixed(2) : (unitPrice ?? '');

          tooltipText = `Special: ${priceStr} ${currencyName} - min. x${moq}`;
        }
      }
    }

    // Check for SpecialPriceList flag
    const isSpecialList = cartItem?.SelectedOffer?.Configuration?.SpecialPriceList === true;
    if (isSpecialList) {
      showTriangle = true;
      if (!tooltipText) {
        tooltipText = translate?.instant('IncreaseQuantityForSpecialPrice') ?? 'Special price available';
      }
      priceClass = 'special-price-highlight';
    }

    const triangle = showTriangle
    ? `<button class="price-corner-triangle dropdown-trigger"
               data-row="${rowIndex}"
               data-type="productSpecials"
               data-tooltip="${tooltipText}"
               aria-label="${tooltipText}"></button>`
    : '';

    return `
      <div class="price-cell-wrapper">
        <span class="${priceClass}">${price}</span>
        ${triangle}
      </div>
    `;
  }

  ETACellRenderer(params: any): string {
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;

    // Build ETA text + "(Stock)" just like your old valueGetter
    const base = (params.data?.eta || '').toString().trim();
    const isStock = cartItem?.SelectedOffer?.IsStockOffer;
    const isManufacturerStock = cartItem?.SelectedOffer?.IsManufacturerStockOffer === true;
    // Only show "(Stock)" if it's stock AND NOT manufacturer stock
    const showStock = isStock && isManufacturerStock !== true;
    const etaText = (base + (showStock ? (base ? ' ' : '') + '(Stock)' : '')).trim() || '------';

    // Show the same dropdown condition as your Name column
    const hasDropdown = cartItem?.CartItemStatus?.ID === 1;

    const dropdownButton = hasDropdown
      ? `<button class="dropdown-trigger material-icon-trigger" data-row="${rowIndex}" data-type="ALLETAs" title="View ALL ETA's">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';

    // ✅ Trusted Manufacturer Lead Time feature
    const isTrusted = cartItem?.Product?.Stats?.TrustedManufacturerLeadTime === true;

    // Render the trusted icon (Material Icons verified badge)
    // Tooltip is handled by AG Grid's tooltipValueGetter in column definition
    const trustedIcon = isTrusted
      ? `<i class="material-icons trusted-icon"
            style="color: #32aa3a; font-size: 18px; margin-right: 6px; vertical-align: middle; cursor: help;">verified</i>`
      : '';

    // 🔴 Use the SAME wrapper classes as Name so existing CSS applies
    return `
      <span class="name-cell-content">
        <span class="${base ? 'eta-text' : 'eta-placeholder'}" style="display: flex; align-items: center;">
          ${trustedIcon}${etaText}
        </span>
        <span class="cell-actions">${dropdownButton}</span>
      </span>
    `;
  }

  // add to the component class
  BrandCellRenderer(params: any): string {
    const brand = (params.value ?? '').toString().trim();
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;
  
    const statusId = cartItem?.CartItemStatus?.ID;
  
    // Existing condition (awaiting selection / valid w/ collateral)
    const showExistingButton =
      cartItem?.WasSearchedFor == true &&
      (statusId === -1 || statusId === 1);
  
    // NEW condition: show **suggestion** button only when NOT VALID (ID === 0)
    const showSuggestButton = statusId === 0;
  
    const existingBtn = showExistingButton
      ? `<button class="dropdown-trigger dropdown-trigger-brand material-icon-trigger"
                   data-row="${rowIndex}"
                   data-type="brand-collateral"
                   title="View brand alternatives">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';
  
    // 🔵 New button (same look), uses data-type="brand-suggest"
    const suggestBtn = showSuggestButton
      ? `<button class="dropdown-trigger dropdown-trigger-brand material-icon-trigger"
                   data-row="${rowIndex}"
                   data-type="brand-suggest"
                   title="Suggest brands for this product">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';
  
    return `
      <span class="brand-cell-content">
        <span class="brand-text">${brand}</span>
        <span class="cell-actions">
          ${existingBtn}
          ${suggestBtn}
        </span>
      </span>
    `;
  }
  
  NameCellRenderer(params: any): string {
    const eta = params.value?.toString().trim() ?? '';
    const isEmpty = eta.length === 0;
    const rowIndex = params.rowIndex;
    const cartItem = params.data?.CartItem;
    const placeholder = this.namePlaceholder || 'Search product or part number...';
  
     // 🔸 Show fallback dropdown when in "awaiting selection" state
    const showFallbackDropdown = cartItem?.CartItemStatus?.ID === -1;

    const hasDropdown = cartItem?.CartItemStatus?.ID === 1 && cartItem?.SearchResults?.length > 1;
    const dropdownButton = hasDropdown
      ? `<button class="dropdown-trigger material-icon-trigger" data-row="${rowIndex}" data-type="productalternatives" title="View Product-Alternatives">
           <i class="material-icons">expand_more</i>
         </button>`
      : '';

    const fallbackButton = showFallbackDropdown
    ? `<button class="dropdown-trigger material-icon-trigger fallbackButtonTrigger" data-row="${rowIndex}" data-type="fallback" title="Show UI fallback offers">
         <i class="material-icons">expand_more</i>
       </button>`
    : '';
  
    const displayText = isEmpty
      ? `<span class="name-placeholder">${placeholder}</span>`
      : `<span class="name-text">${eta}</span>`;
  
    return `
      <span class="name-cell-content">
        ${displayText}
        <span class="cell-actions">
          ${dropdownButton}
          ${fallbackButton}
        </span>
      </span>
    `;
  }

  officialListPriceCellRenderer = (params: any): string => {
    const olp = params.data?.CartItem?.Product?.Stats?.StandardListPrice;
    const amount = olp?.UIUnitPrice;

    // If price is missing -> empty string (currency is now in header)
    if (
      amount == null ||
      (typeof amount !== 'number' && isNaN(Number(amount)))
    ) {
      return '';
    }

    const amtStr = typeof amount === 'number' ? amount.toFixed(2) : String(amount);
    return `<span class="official-list-price">${amtStr}</span>`;
  };

  /**
   * Get List-Price header with currency symbol
   */
  getListPriceHeader(): string {
    const currencySymbol = this.parent.Cart?.Currency?.Symbol || '';
    return currencySymbol ? `${currencySymbol} List-Price` : 'List-Price';
  }

  /**
   * Get Final-Price header with currency symbol
   */
  getFinalPriceHeader(): string {
    const currencySymbol = this.parent.Cart?.Currency?.Symbol || '';
    return currencySymbol ? `${currencySymbol} Final-Price` : 'Final-Price';
  }

  /**
   * Get Total header with currency symbol
   */
  getTotalHeader(): string {
    const currencySymbol = this.parent.Cart?.Currency?.Symbol || '';
    return currencySymbol ? `${currencySymbol} Total` : 'Total';
  }

  /**
   * Update column headers with current currency symbol
   */
  updateColumnHeaders(): void {
    if (this.gridApi && this.columnApi) {
      const listPriceCol = this.columnApi.getColumn('officialListPrice');
      const finalPriceCol = this.columnApi.getColumn('price');
      const totalCol = this.columnApi.getColumn('total');

      if (listPriceCol) {
        const colDef = listPriceCol.getColDef();
        colDef.headerName = this.getListPriceHeader();
      }

      if (finalPriceCol) {
        const colDef = finalPriceCol.getColDef();
        colDef.headerName = this.getFinalPriceHeader();
      }

      if (totalCol) {
        const colDef = totalCol.getColDef();
        colDef.headerName = this.getTotalHeader();
      }

      // Refresh headers
      this.gridApi.refreshHeader();

      console.log('✅ Column headers updated with currency:', this.parent.Cart?.Currency?.Symbol);
    }
  }
  
  officialDiscountCellRenderer = (params: any): string => {
    const raw = params.data?.CartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value;
  
    // No info -> empty
    if (raw == null || raw === '') return '';
  
    // Format number nicely (keep integers, max 2 decimals, trim trailing zeros)
    const n = Number(raw);
    const valStr = Number.isFinite(n)
      ? (n % 1 === 0
          ? String(n)
          : n.toFixed(2).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1'))
      : String(raw).trim();
  
    return `<span class="official-discount">${valStr}%</span>`;
  };

  isHovering = false;

  ngOnInit(): void {
    // ✅ Load Offer Request Master Data (OrderConsolidationTypes, OrderDeliveryPreferences)
    this.GetOfferMasterData();
    this.loadAgentOrderPhases();

    // Register PDF export tracking callback with parent
    this.parent.registerPDFExportCallback(() => {
      this.TrackB2BUserGridEvent(4); // eB2BUserTrackingEventType.ExportOfficialOfferPDF
    });

    this.translate.use(this.parent.getLanguage()).subscribe(() => {
      // Load translations at once
      this.translate.get([
        'SearchProductOrPartNumberHere',
        'MOQAdjustmentClientUI'
      ]).subscribe(translations => {
        this.namePlaceholder = translations['SearchProductOrPartNumberHere'];
        this.MOQAdjustmentTooltip = translations['MOQAdjustmentClientUI'];
        this.specialPriceCellTranslation = translations["IncreaseQuantityForSpecialPrice"];

        // Now that translations are ready, proceed
        this.InitializeFilter();
        this.GetB2BHomePageMessage();
        this.CartItemRows = [];

      });
    });

      // ✅ Intercept and count clipboard lines — used only for info
      // document.addEventListener('paste', (event: ClipboardEvent) => {
      //   const text = event.clipboardData?.getData('text/plain') ?? '';
      //   const lines = text.split(/\r?\n/).filter(line => line.trim());
      //   this.pastedLineCount = lines.length;
      // });

    // Debounce paste handling
    this.pasteSubject
        .pipe(debounceTime(250))
        .subscribe(() => {
          const unique = new Map<number, { name: string; quantity: any }>();
          this.pastedRows.forEach(r => unique.set(r.rowIndex, { name: r.name, quantity: r.quantity }));
          this.pastedRows = [];

          const entries = Array.from(unique.entries());
          if (entries.length === 0) return;

          // ✅ Build searchable entries (skip rows that shouldn't be searched)
          const searchableEntries = entries.filter(([rowIndex]) => this.shouldSearch(rowIndex));
          if (searchableEntries.length === 0) return;

          // ✅ If only 1 item, use the single search (no need for bulk)
          if (searchableEntries.length === 1) {
            const [rowIndex, payload] = searchableEntries[0];
            this.pendingPasteRowIndexes.add(rowIndex);
            this.SearchIndustryProductB2BOffersVersion2(rowIndex, payload.name, payload.quantity, () => {
              this.onPasteRowCompleted(rowIndex);
            });
            this.resetPasteCompletionTimer();
            return;
          }

          // ✅ Multiple items: use BULK endpoint (1 HTTP call instead of N)
          const searchItems = searchableEntries.map(([rowIndex, payload]) => ({
            RowIndex: rowIndex,
            SearchTerm: payload.name,
            Quantity: payload.quantity?.toString() || '1',
            BrandID: null
          }));

          // Mark all rows as pending + show loading
          searchableEntries.forEach(([rowIndex]) => {
            this.pendingPasteRowIndexes.add(rowIndex);
            const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
            if (rowNode?.data?.CartItem) {
              rowNode.data.CartItem.LoadingCell = true;
              this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['name'], force: true });
            }
          });

          this.loadingProducts = true;
          this.parent.loading = true;

          const bulkRequest = {
            User: this.parent.User,
            Language: this.parent.getLanguage(),
            PartnerID: this.parent.B2BPartner?.ID,
            SearchItems: searchItems,
            Pager: { PageIndex: 1, PageSize: 15 },
            MaxRank: 10,
            IsAdmin: false,
            ApplyClientRestrictions: true,
            FinancialStatus: this.parent.B2BPartner?.FinancialData?.Status,
            PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
            PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
            PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
            PreloadedPartner: this.parent.B2BPartner || null,
            PreloadedIsBlocked: this.parent.B2BPartner?.FinancialData?.Status?.ID === -3 ? true : false,
          };

          this.B2BService.BulkSearchIndustryProductB2BOffersVersion2(bulkRequest).subscribe(response => {
            if (response?.Results) {
              for (const result of response.Results) {
                if (result.CartItem) {
                  const c = JSON.parse(JSON.stringify(result.CartItem));
                  c.LoadingCell = false;
                  this.applyCartItemToRow(result.RowIndex, c);
                }
                this.onPasteRowCompleted(result.RowIndex);
              }
            }

            this.loadingProducts = false;
            this.parent.loading = false;

            // ✅ Track paste event
            this.TrackB2BUserGridEvent(this.pasteEventType || 2);
            this.pasteEventType = null;
          });

          this.resetPasteCompletionTimer(); // fallback just in case
        });

        document.addEventListener('copy', this.onCopyHandler.bind(this));
  }

  onCopyHandler(e: ClipboardEvent): void {
    if (!this.gridApi || !this.gridApi.getFocusedCell()) return;

    const range = this.gridApi.getCellRanges()?.[0];
    if (!range) return;

    const rowStart = range.startRow.rowIndex;
    const rowEnd = range.endRow.rowIndex;
    const allCols = range.columns;

    // Step 1: Collect all data from selected rows
    const rawRows: string[][] = [];
    const colValuePresence = new Array(allCols.length).fill(false); // Track non-empty columns
    let totalSum = 0; // Track sum of Total column
    let totalColIndex = -1; // Index of 'total' column
    let priceColIndex = -1; // Index of 'price' (Final-Price) column

    for (let i = rowStart; i <= rowEnd; i++) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(i);
      const row: string[] = [];

      allCols.forEach((col, colIndex) => {
        const colField = col.getColDef().field;
        const value = (this.gridApi.getValue(col, rowNode) ?? '').toString().trim();
        row.push(value);
        if (value.length > 0) {
          colValuePresence[colIndex] = true;
        }

        // Track Total column for sum calculation
        if (colField === 'total') {
          totalColIndex = colIndex;
          const numValue = parseFloat(value.replace(/[^\d.-]/g, ''));
          if (!isNaN(numValue)) {
            totalSum += numValue;
          }
        }

        // Track Final-Price column for "Total:" label
        if (colField === 'price') {
          priceColIndex = colIndex;
        }
      });

      rawRows.push(row);
    }

    // Step 2: Build list of columns to keep (those with at least one non-empty value)
    const includedColIndexes = allCols
      .map((_, idx) => idx)
      .filter(idx => colValuePresence[idx]);

    const includedCols = includedColIndexes.map(idx => allCols[idx]);

    // Find the position of total and price columns in the included columns
    const includedTotalColPos = includedColIndexes.indexOf(totalColIndex);
    const includedPriceColPos = includedColIndexes.indexOf(priceColIndex);

    // Step 3: Build plain text (fallback)
    let plainText = rawRows
      .map(row => includedColIndexes.map(i => row[i]).join('\t'))
      .join('\n');

    // Add total row to plain text
    if (includedTotalColPos >= 0) {
      const totalRow = new Array(includedColIndexes.length).fill('');
      if (includedPriceColPos >= 0) {
        totalRow[includedPriceColPos] = 'Total:';
      }
      totalRow[includedTotalColPos] = totalSum.toFixed(2);
      plainText += '\n' + totalRow.join('\t');
    }

    // Step 4: Build HTML table
    let html = '<table border="1" cellpadding="4" cellspacing="0" style="border-collapse: collapse;">';

    // Header
    html += '<thead><tr>';
    for (const col of includedCols) {
      html += `<th style="background: #020044; color: #ffffff; font-size: 14px; font-weight: normal;">${col.getColDef().headerName || ''}</th>`;
    }
    html += '</tr></thead>';

    // Body
    html += '<tbody>';
    for (const row of rawRows) {
      html += '<tr>';
      for (const i of includedColIndexes) {
        html += `<td style="font-size: 12px;">${row[i]}</td>`;
      }
      html += '</tr>';
    }

    // Add Total row
    if (includedTotalColPos >= 0) {
      html += '<tr style="font-weight: bold; background: #f0f0f0;">';
      for (let j = 0; j < includedColIndexes.length; j++) {
        if (j === includedPriceColPos) {
          html += `<td style="font-size: 12px; text-align: right;">Total:</td>`;
        } else if (j === includedTotalColPos) {
          html += `<td style="font-size: 12px;">${totalSum.toFixed(2)}</td>`;
        } else {
          html += `<td style="font-size: 12px;"></td>`;
        }
      }
      html += '</tr>';
    }

    html += '</tbody></table>';

    // Step 5: Apply to clipboard
    e.preventDefault();
    e.clipboardData.setData('text/plain', plainText);
    e.clipboardData.setData('text/html', html);
  }

  private onPasteRowCompleted(rowIndex: number): void {
    this.pendingPasteRowIndexes.delete(rowIndex);

    if (this.pendingPasteRowIndexes.size === 0) {
      this.triggerFinalCartUpdate();

      // ✅ Track paste event ONCE after all rows complete
      if (this.pasteEventType !== null) {
        this.TrackB2BUserGridEvent(this.pasteEventType);
        this.pasteEventType = null;
        this.isPasting = false;
      }
    }
  }

  private resetPasteCompletionTimer(): void {
    if (this.pasteSyncTimer) {
      clearTimeout(this.pasteSyncTimer);
    }

    this.pasteSyncTimer = setTimeout(() => {
      if (this.pendingPasteRowIndexes.size > 0) {
        console.warn('⚠️ Fallback: Force cart update after timeout');
        this.pendingPasteRowIndexes.clear();
        this.triggerFinalCartUpdate();

        // ✅ Track paste event even on timeout
        if (this.pasteEventType !== null) {
          this.TrackB2BUserGridEvent(this.pasteEventType);
          this.pasteEventType = null;
          this.isPasting = false;
        }
      }
    }, 10000); // Fallback timeout: 10 seconds
  }

  private triggerFinalCartUpdate(): void {
    this.UpdateCart();
    console.log('✅ All pasted rows processed, cart updated.');
  }

    /** Return true if we are allowed to search for this row */
  private shouldSearch(rowIndex: number): boolean {
    const node = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    const wasSearched = node?.data?.CartItem?.WasSearchedFor === true;
    return !wasSearched; // allow when false/undefined/null
  }

  onGridReady(params: any): void {
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const storedCart = localStorage.getItem("Cart");
      if (storedCart) {
        this.GetCart();
        // ✅ Update column headers with currency symbol from loaded cart
        this.updateColumnHeaders();
      } else {
        this.addMoreRows(50);
      }

    // Listen to raw paste to count rows
    // const gridElement = document.querySelector('.ag-root') as HTMLElement;
    // if (gridElement) {
    //   gridElement.addEventListener('paste', (e: ClipboardEvent) => {
    //     const text = e.clipboardData?.getData('text/plain') ?? '';
    //     this.pastedLineCount = text.split(/\r?\n/).filter(line => line.trim()).length;
    //   });
    // }

    // Attach custom grid cell click listener
    setTimeout(() => {
      const gridElement = document.querySelector('.ag-root');
      if (gridElement) {
        gridElement.addEventListener('click', this.onGridCellButtonClick.bind(this));
      }
    }, 0);
  }

  ClickedRow:any;
  ClickedRowIndex:number;
  ShowBrandCollateral: boolean = false;
  BrandPopupPosition: { top: string; left: string; width: string } = {
    top: '0px',
    left: '0px',
    width: '0px'
  };

  onGridCellButtonClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target) return;
  
    // 1) 🔵 Datasheet (PDF) click — new
    const pdfBtn = target.closest('.pdf-datasheet-button') as HTMLElement | null;
    if (pdfBtn) {
      const href = (pdfBtn.getAttribute('data-href') || '').trim();
      if (href) {
        // open safely in a new tab
        window.open(href, '_blank', 'noopener,noreferrer');
      }
      return; // stop further handling
    }
  
    // 2) 🗑 Delete row — unchanged behavior
    if (target.closest('.delete-row-button')) {
      const cell = target.closest('.ag-cell') as HTMLElement;
      const rowElement = cell?.parentElement as HTMLElement;
      const rowIndex = Array.from(rowElement?.parentElement?.children || []).indexOf(rowElement);
      if (rowIndex >= 0) this.deleteRow(rowIndex);
      return;
    }
  
    // 3) 🔽 Any dropdown trigger (brand + others) — unchanged behavior
    const trigger = target.closest('.dropdown-trigger, .dropdown-trigger-brand') as HTMLElement | null;
    if (!trigger) return;
  
    const rowIndex = Number(trigger.getAttribute('data-row'));
    const type = trigger.getAttribute('data-type') || 'name';
    const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    const cartItem = rowNode?.data?.CartItem;
    if (!cartItem) return;
  
    this.ClickedRow = JSON.parse(JSON.stringify(rowNode?.data));
    this.ClickedRowIndex = rowIndex;
  
    const cellElement = trigger.closest('.ag-cell') as HTMLElement;
    const containerElement = document.querySelector('.OwnAGGridContainer') as HTMLElement;
    if (!cellElement || !containerElement) return;
  
    const cellRect = cellElement.getBoundingClientRect();
    const containerRect = containerElement.getBoundingClientRect();
    const top  = cellRect.top  - containerRect.top + cellElement.offsetHeight + 5;
  
    // 3a) BRAND collateral popup — unchanged
    if (type === 'brand-collateral') {
      const left = cellRect.left - containerRect.left;
      const width = cellRect.width;
  
      this.BrandPopupPosition = { top: `${top}px`, left: `${left}px`, width: `${width}px` };
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.ShowFallbackSelection = false;
  
      this.SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(rowIndex, cartItem);
      return;
    }
  
    // 3b) BRAND suggest popup — unchanged
    if (type === 'brand-suggest') {
      this.BrandPopupPosition = {
        top: `${top}px`,
        left: `${cellRect.left - containerRect.left}px`,
        width: `${cellRect.width}px`
      };
  
      const implicitProduct = (cartItem?.UIProductValue ?? '');
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.ShowFallbackSelection = false;
      this.ShowBrandCollateral = false;
      this.BrandSelectList = [];
  
      this.InitializeBrandFilter();
      this.GetBrandsFilteredWithSuggestion('', 1, implicitProduct);
      return;
    }
  
    // 3c) Full-width overlays (fallback / alternatives / ETAs) — unchanged
    const fullLeft = 5; // align with grid container’s left
    const fullWidth = containerRect.width;
    this.SearchResultsPosition = { top: `${top}px`, left: `${fullLeft}px`, width: `${fullWidth}px` };
  
    if (type === 'fallback') {
      this.ShowUISideOffers(rowIndex, cartItem);
      return;
    }

    // ✅ Ask-Price button for invalid items (CartItemStatus.ID === 0)
    if (type === 'askPrice') {
      const searchTerm = trigger.getAttribute('data-search') || cartItem?.UIProductValue || '';
      this.OpenDetectedProductPopup(rowIndex, searchTerm);
      return;
    }

    if (type === 'productalternatives' || type === 'ALLETAs' || type === 'productSpecials') {
      this.ShowETAAlternatives = true;
      this.ShowSearchResultsAlternatives = false;
  
      const productIds = (cartItem?.SearchResults ?? []).map((s: any) => s.ProductID);
      const offerId = cartItem?.Product?.ListPriceOffers?.[0]?.ID;
  
      if (type === 'productalternatives') {
        if (productIds?.length) {
          this.GetIndustryProductCalculatedSideOffersWithCollateral(
            rowIndex,
            productIds,
            offerId,
            this.ClickedRow?.CartItem?.Product?.Brand,
            true,  // BestOfferOnly
            true,  // GetAlsoCollateralSpecialOffers
            false  // GetOnlySpecialOffers
          );
        }
        return;
      }
  
      if (type === 'ALLETAs') {
        this.GetIndustryProductCalculatedSideOffers(
          rowIndex,
          this.ClickedRow?.CartItem?.Product?.ID,
          offerId
        );
        return;
      }
  
      if (type === 'productSpecials') {
        if (productIds?.length) {
          this.GetIndustryProductCalculatedSideOffersWithCollateral(
            rowIndex,
            productIds,
            offerId,
            this.ClickedRow?.CartItem?.Product?.Brand,
            true,  // BestOfferOnly
            true,  // GetAlsoCollateralSpecialOffers
            true   // GetOnlySpecialOffers
          );
        }
        return;
      }
    }
  
    // 3d) Default: show full search results alternatives — unchanged
    this.ShowSearchResultsAlternatives = true;
    this.ShowETAAlternatives = false;
    this.SearchResultAlternatives = JSON.parse(JSON.stringify(cartItem?.SearchResults ?? []));
  }
  

  ShowFallbackSelection:boolean = false;
  FallbackOffers:any[];

  ShowUISideOffers(rowIndex: number, cartItem:any): void {
    console.log('🟡 ShowUISideOffers triggered for row', rowIndex);
    this.ShowFallbackSelection = true;
    this.FallbackOffers = null;
    this.FallbackOffers = [];
    // You can implement the logic later, e.g., open a popup or fallback search.

    this.FallbackOffers = cartItem?.FallbackOffers;
  }

  deleteRow(rowIndex: number): void {
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;
  
    const dataToRemove = rowNode.data;
  
    // Remove row from AG Grid
    this.gridApi.applyTransaction({ remove: [dataToRemove] });
  
    // ✅ Optional: Re-index the remaining rows for correct # display
    const allData: any[] = [];
    this.gridApi.forEachNode((node, idx) => {
      node.data.index = idx + 1;
      allData.push(node.data);
    });
    this.gridApi.setRowData(allData); // reset with updated indices
  
    // ✅ Now persist the updated cart
    this.UpdateCart();
  }
  
  CloseGridPopupsOverlay(){
    this.ShowSearchResultsAlternatives = false;
    this.ShowETAAlternatives = false;
    this.ShowFallbackSelection = false;
    this.ShowBrandCollateral = false;
    this.ShowBrandCollateralNewProduct = false;
  }

  ShowSearchResultsAlternatives:boolean = false;
  ShowETAAlternatives:boolean = false;
  SearchResultAlternatives:any[];

  showSearchResultDropdown(rowIndex: number, searchResults: any[]): void {
    this.ShowSearchResultsAlternatives = true;
    this.SearchResultAlternatives = JSON.parse(JSON.stringify(searchResults));
  
    setTimeout(() => {
      const cellButton = document.querySelector(`.dropdown-trigger[data-row="${rowIndex}"]`) as HTMLElement;
      const gridContainer = document.querySelector('.OwnAGGridContainer') as HTMLElement;
  
      if (!cellButton || !gridContainer) return;
  
      // Accumulate offset relative to grid container
      let offsetTop = 0;
      let offsetLeft = 0;
      let el: HTMLElement | null = cellButton;
  
      while (el && el !== gridContainer) {
        offsetTop += el.offsetTop;
        offsetLeft += el.offsetLeft;
        el = el.offsetParent as HTMLElement;
      }
  
      this.SearchResultsPosition = {
        top: `${offsetTop + cellButton.offsetHeight}px`, // below the cell
        left: `${offsetLeft}px`,                         // aligned left
        width: '450px'                                   // match 'name' column width
      };
    }, 0);
  }

  SearchResultsPosition: { top: string; left: string; width: string } = {
    top: '0px',
    left: '0px',
    width: '0px'
  };

  onCellValueChanged(event: any): void {
    const field = event.colDef.field;
    const rowIndex = event.rowIndex;
    const rowNode = event.api.getDisplayedRowAtIndex(rowIndex);

    if (!rowNode) return;

    // ---------- Quantity changes ----------
    if (field === 'quantity') {
      const cartItem = rowNode.data?.CartItem;

      // Normalize to numbers and compare numerically
      const newNum = Number(event.newValue);
      const oldNum = Number(event.oldValue);

      // Only act when the new value is a number AND actually changed
      if (Number.isFinite(newNum) && newNum !== oldNum) {
        this.ChangeGridQuantityVersion2(rowIndex, newNum, cartItem);
      }
      return; // nothing else to do
    }

    // ---------- Name changes (your existing flow, unchanged) ----------
    if (field !== 'name') return;

    const newValue = (event.newValue ?? '').toString().trim();
    if (!newValue) return;

    const oldValue = (event.oldValue ?? '').toString().trim();
    if (oldValue !== newValue && oldValue.length > 0 && newValue.length > 0) {
      if (rowNode?.data?.CartItem?.WasSearchedFor === true) {
        rowNode.data.CartItem.WasSearchedFor = false;
      }
    }

    const wasSearched = rowNode?.data?.CartItem?.WasSearchedFor === true;
    if (wasSearched) return;

    // ✅ Detect if this is keyboard typing (not from paste)
    if (this.currentSearchSource === null && !this.isPasting) {
      this.currentSearchSource = 'keyboard';
    }

    const quantity = rowNode?.data?.quantity ?? '';
    this.pastedRows.push({ rowIndex, name: newValue, quantity });
    this.pasteSubject.next();
  }
  
  handlePaste(params: any): void {
    this.gridApi.stopEditing(); // ✅ Prevent AG Grid from showing paste confirmation

    this.pastedRows = null;
    this.pastedRows = [];
  
    const seen = new Set<number>();
    const allPastedRows: { rowIndex: number; name: string; quantity: any }[] = [];
  
    params.api.forEachNode((node: any) => {
      if (!node || node.rowIndex == null) return;
  
      const rowIndex = node.rowIndex;
      const name = node.data?.name ?? '';
      if (!name || !name.trim()) return;
  
      if (!seen.has(rowIndex)) {
        const quantity = node.data?.quantity ?? '';
        allPastedRows.push({ rowIndex, name, quantity });
        seen.add(rowIndex);
      }
    });
  
    let trimmedRows = allPastedRows;
    if (allPastedRows.length > this.MAX_PASTE_ROWS) {
      trimmedRows = allPastedRows.slice(0, this.MAX_PASTE_ROWS);
  
      for (let i = this.MAX_PASTE_ROWS; i < allPastedRows.length; i++) {
        const rowIndex = allPastedRows[i].rowIndex;
        const node = this.gridApi.getDisplayedRowAtIndex(rowIndex);
        if (node?.data) {
          node.setDataValue('name', '');
          node.setDataValue('quantity', null);
        }
      }
  
      this.parent.openSnackBar(
        `⚠️ Paste limited to ${this.MAX_PASTE_ROWS} items.`,
        'OK',
        'alert-info-snackbar'
      );
    }
  
    const lastRowIndex = trimmedRows.length > 0
      ? trimmedRows[trimmedRows.length - 1].rowIndex
      : 0;
  
    const currentRowCount = this.gridApi.getDisplayedRowCount();
    const requiredRowCount = lastRowIndex + 1;
  
    const finalize = () => {
      this.pastedRows.push(...trimmedRows);
      this.pasteSubject.next();
  
      // ✅ RESET counter after successful paste
      this.pastedLineCount = 0;
    };
  
    if (requiredRowCount > currentRowCount) {
      const rowsToAdd = requiredRowCount - currentRowCount;
      this.addMoreRows(rowsToAdd);
  
      setTimeout(finalize, 50);
    } else {
      finalize();
    }
  
    console.log('📋 Trimmed + cleaned paste rows:', trimmedRows.length);
  }

  // Delete selected rows based on cell ranges
  deleteSelectedRows(cellRanges: any[]): void {
    try {
      // Collect all unique row indices from all cell ranges
      const rowIndicesToDelete = new Set<number>();

      cellRanges.forEach(range => {
        const startRow = Math.min(range.startRow.rowIndex, range.endRow.rowIndex);
        const endRow = Math.max(range.startRow.rowIndex, range.endRow.rowIndex);

        // Add all row indices in this range
        for (let i = startRow; i <= endRow; i++) {
          rowIndicesToDelete.add(i);
        }
      });

      if (rowIndicesToDelete.size === 0) {
        return;
      }

      // Convert to sorted array (delete from bottom to top to avoid index shifting)
      const sortedIndices = Array.from(rowIndicesToDelete).sort((a, b) => b - a);

      console.log('🗑️ Deleting rows:', sortedIndices);

      // Get the row nodes and their UIIDs
      const rowsToDelete: any[] = [];
      sortedIndices.forEach(rowIndex => {
        const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
        if (rowNode && rowNode.data) {
          rowsToDelete.push({
            rowIndex: rowIndex,
            uiid: rowNode.data.CartItem?.UIID,
            data: rowNode.data
          });
        }
      });

      // Remove from parent.Cart.Items if they have UIIDs
      rowsToDelete.forEach(row => {
        if (row.uiid) {
          this.parent.Cart.Items = this.parent.Cart.Items.filter((item: any) => item.UIID !== row.uiid);
        }
      });

      // Remove rows from grid (from bottom to top)
      const transaction: any = {
        remove: rowsToDelete.map(r => r.data)
      };
      this.gridApi.applyTransaction(transaction);

      // Update cart
      this.UpdateCart();

      // Check if grid is now empty and reset GridID + tracking data
      const remainingRows = this.gridApi.getDisplayedRowCount();
      if (remainingRows === 0) {
        this.resetGridID();
        localStorage.removeItem('B2BUserTracking'); // ✅ Also delete tracking data
        console.log('🔄 Grid emptied - GridID and tracking data reset');
      }

      // Show feedback
      this.parent.openSnackBar(
        `Deleted ${rowsToDelete.length} row(s)`,
        'OK',
        'alert-info-snackbar'
      );

      console.log('✅ Rows deleted successfully');

    } catch (error) {
      console.error('❌ Error deleting rows:', error);
      this.parent.openSnackBar(
        'Error deleting rows',
        'OK',
        'alert-info-snackbar'
      );
    }
  }

  // Trigger paste from context menu using Clipboard API
  async triggerPasteFromContextMenu(params: any): Promise<void> {
    try {
      // ✅ Mark as right-click paste (mouse paste)
      this.isPasting = true;
      this.pasteEventType = 3; // eB2BUserTrackingEventType.CopyPasteMouse

      // Read from clipboard
      const clipboardText = await navigator.clipboard.readText();

      if (!clipboardText || clipboardText.trim() === '') {
        this.parent.openSnackBar('Clipboard is empty', 'OK', 'alert-info-snackbar');
        this.isPasting = false;
        this.pasteEventType = null;
        return;
      }

      // Get the focused cell or first cell if none focused
      let startRowIndex = 0;
      let startColKey = 'name';

      const focusedCell = params.api.getFocusedCell();
      if (focusedCell) {
        startRowIndex = focusedCell.rowIndex;
        startColKey = focusedCell.column.getColId();
      }

      // Parse clipboard data (tab-separated for columns, newline for rows)
      const rows = clipboardText.split(/\r?\n/).filter(line => line.trim() !== '');

      // Process each row
      const allPastedRows: { rowIndex: number; name: string; quantity: any }[] = [];

      for (let i = 0; i < rows.length; i++) {
        const rowIndex = startRowIndex + i;
        const rowData = rows[i].split('\t');

        // Ensure we have enough rows in the grid
        const currentRowCount = this.gridApi.getDisplayedRowCount();
        if (rowIndex >= currentRowCount) {
          this.addMoreRows(rowIndex - currentRowCount + 1);
          await new Promise(resolve => setTimeout(resolve, 50));
        }

        const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
        if (!rowNode) continue;

        // Determine which columns to paste based on start column
        let nameValue = '';
        let quantityValue = '';

        if (startColKey === 'name') {
          nameValue = rowData[0] || '';
          quantityValue = rowData[1] || '';
        } else if (startColKey === 'quantity') {
          quantityValue = rowData[0] || '';
        } else {
          // For other columns, just paste into name
          nameValue = rowData[0] || '';
        }

        // Update the grid cells
        if (nameValue) {
          rowNode.setDataValue('name', nameValue);
        }
        if (quantityValue) {
          rowNode.setDataValue('quantity', quantityValue);
        }

        // Track for search
        if (nameValue) {
          allPastedRows.push({ rowIndex, name: nameValue, quantity: quantityValue });
        }
      }

      // Limit to MAX_PASTE_ROWS
      let trimmedRows = allPastedRows;
      if (allPastedRows.length > this.MAX_PASTE_ROWS) {
        trimmedRows = allPastedRows.slice(0, this.MAX_PASTE_ROWS);
        this.parent.openSnackBar(
          `⚠️ Paste limited to ${this.MAX_PASTE_ROWS} items.`,
          'OK',
          'alert-info-snackbar'
        );
      }

      // Trigger search for pasted items
      this.pastedRows.push(...trimmedRows);
      this.pasteSubject.next();

      console.log('📋 Context menu paste completed:', trimmedRows.length, 'rows');

    } catch (error) {
      console.error('❌ Paste from context menu failed:', error);
      this.parent.openSnackBar(
        'Paste failed. Please use Ctrl+V or ensure clipboard permissions are granted.',
        'OK',
        'alert-info-snackbar'
      );
    }
  }


  LoadingSideOffers:boolean = false;
  SideOffers:any[];

  GetIndustryProductCalculatedSideOffersWithCollateral(rowIndex:number, IndustryProductIDs:number[], offerId:number, UIBrand:any, BestOfferOnly:boolean, GetAlsoCollateralSpecialOffers:boolean, GetOnlySpecialOffers: boolean){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      IndustryProductIDs:IndustryProductIDs,
      SelectedOfferID:offerId,
      BestOfferOnly:BestOfferOnly,
      GetAlsoCollateralSpecialOffers:GetAlsoCollateralSpecialOffers,
      GetOnlySpecialOffers:GetOnlySpecialOffers,
      Brand:UIBrand,
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductCalculatedSideOffersWithCollateral(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }
  
      this.LoadingSideOffers = false;
     });
  }

  GetIndustryProductCalculatedSideOffers(rowIndex:number, IndustryProductID:number, offerId:number){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      IndustryProductID:IndustryProductID,
      SelectedOfferID:offerId
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductCalculatedSideOffers(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }
  
      this.LoadingSideOffers = false;
     });
  }

  GetIndustryProductByStockOverRequestedQuantity(rowIndex:number, overFlowingCartItem:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      CartItem:overFlowingCartItem,
      B2BAdminSettings: {
        AdminToken: this.parent.User?.Id,
        PrefferedCurrency: this.parent.Cart?.Currency,
        ConfigStatus: { ID: 1, Name: 'Active' }
      }
    };

    this.SideOffers = null;
    this.SideOffers = [];

    this.LoadingSideOffers = true;
  
    this.B2BService.GetIndustryProductByStockOverRequestedQuantity(request).subscribe(response => {

      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        // Check if no other offers are available
        if(response["NoOtherOffersAvailable"] == true){
          this.stockReadjustedMessage = response["NoOtherOffersMessage"];
          this.stockReadjustedProducts = [];
          this.showStockReadjustedPopup = true;
        }
        this.SideOffers = JSON.parse(JSON.stringify(response["CartItems"]));
      }

      this.LoadingSideOffers = false;
     });
  }
  
  // Track if current search is from paste or keyboard
  private currentSearchSource: 'keyboard' | 'paste-keyboard' | 'paste-mouse' | null = null;
  private isPasting: boolean = false;
  private pasteEventType: number | null = null; // Store which paste event type (2 or 3)

  SearchIndustryProductB2BOffersVersion2(rowIndex: number, searchTerm: string, quantity: any, callback?: () => void) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      BrandID: null,
      SearchTerm: searchTerm,
      Quantity: quantity,
      Pager: { PageIndex: 1, PageSize: 15 },
      MaxRank: 10,
      ApplyClientRestrictions:true,
      FinancialStatus: this.parent.B2BPartner?.FinancialData?.Status,
      // ─── Pre-loaded data: eliminates 6 sequential DB fetches per search ───
      PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
      PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
      PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
      PreloadedPartner: this.parent.B2BPartner || null,
      PreloadedIsBlocked: this.parent.B2BPartner?.FinancialData?.Status?.ID === -3 ? true : false,
    };

    const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (rowNode?.data?.CartItem) {
      rowNode.data.CartItem.LoadingCell = true;
      this.gridApi.refreshCells({
        rowNodes: [rowNode],
        columns: ['name'],
        force: true
      });
    }

    this.loadingProducts = true;

    // ✅ Use Combined endpoint - handles short search terms (< 5 chars) via parallel FTS + ExactMatch
    this.B2BService.SearchIndustryProductB2BOffersVersion2Combined(request).subscribe(response => {
      if (response["Status"] === 1 || response["Status"] === -2) {
        const c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(rowIndex, c);

        this.loadingProducts = false;
        this.parent.loading = false;

        if(response["Status"] === -2){
          this.parent.InitializeExitBlockedAccount(response["Message"]);
        }

        // ✅ Track keyboard typing event (only if not from paste)
        if (this.currentSearchSource === 'keyboard') {
          this.TrackB2BUserGridEvent(1); // eB2BUserTrackingEventType.Keyboard
          this.currentSearchSource = null;
        }
      }

      // this.loadingProducts = false;
      // ✅ Inform that this row's async is done
      if (callback) callback();
    });
  }

  SwitchGridProductOffer(item:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      SelectedOffer:item.Product?.ListPriceOffers[0],
      CartItem:this.ClickedRow?.CartItem,
    };
  
    this.LoadingSideOffers = true;
  
    this.B2BService.SwitchGridProductOffer(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(this.ClickedRowIndex, c);
        this.UpdateCart();
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
     });
  }

  SwitchGridBrandVersion2(b:any){
    var request = {
      User:this.parent.User,
      Language:this.parent.getLanguage(),
      PartnerID:this.parent.B2BPartner?.ID,
      CartItem:this.ClickedRow?.CartItem,
      Pager: { PageIndex: 1, PageSize: 25 },
      MaxRank: 100,
      UISelectedBrand:JSON.parse(JSON.stringify(b)),
    };
  
    this.LoadingSideOffers = true;
  
    this.B2BService.SwitchGridBrandVersion2(request).subscribe(response => {
  
      if(response["Status"] != 1){
        // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
      }
      else if(response["Status"] == 1){
        var c = JSON.parse(JSON.stringify(response["CartItem"]));
        c.LoadingCell = false;
        this.applyCartItemToRow(this.ClickedRowIndex, c);
        this.UpdateCart();

        //if still is awaiting selection:
        if(c?.CartItemStatus?.ID == -1){
          this.ShowUISideOffers(this.ClickedRowIndex, this.ClickedRow?.CartItem);
          this.ShowFallbackSelection = true;
        }
      }
  
      this.LoadingSideOffers = false;
      this.ShowBrandCollateral = false;
     });
  }

  BrandCollateralList:any[];
  BrandSelectList:any[];

  SearchIndustryProductB2BBrandsVersion2(rowIndex: number, cartItem: any) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      SearchTerm: cartItem?.UIProductValue,
      ConfigStatusThreshold: 0,
      StockStatus: null,
    };
  
    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;
  
    this.B2BService.SearchIndustryProductB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        const brands = JSON.parse(JSON.stringify(response["Brands"] ?? []));
  
        // put brands on the specific row
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = brands;
  
          // (optional) persist to cart/localStorage
          if (this.parent.Cart?.Items?.[rowIndex]) {
            this.parent.Cart.Items[rowIndex].CollateralBrands = JSON.parse(JSON.stringify(brands));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }
  
          // refresh brand cell so button/state reflects
          this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['brand'], force: true });
        }
  
        // show the brand popup now; position already computed in click handler
        this.BrandCollateralList = brands;
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }
  
  SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(rowIndex: number, cartItem: any) {
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CurrentUISelectedBrand: cartItem?.Product?.Brand?.ID,
      CartItem:JSON.parse(JSON.stringify(cartItem)),
      ConfigStatusThreshold: 0,
      StockStatus: null,
    };
  
    this.ShowBrandCollateral = true;
    this.LoadingSideOffers = true;
  
    this.B2BService.SearchIndustryProductNameAndPartNumberParrallelB2BBrandsVersion2(request).subscribe(response => {
      if (response["Status"] === 1) {
        const brands = JSON.parse(JSON.stringify(response["Brands"] ?? []));
  
        // put brands on the specific row
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = brands;
  
          // (optional) persist to cart/localStorage
          if (this.parent.Cart?.Items?.[rowIndex]) {
            this.parent.Cart.Items[rowIndex].CollateralBrands = JSON.parse(JSON.stringify(brands));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }
  
          // refresh brand cell so button/state reflects
          this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['brand'], force: true });
        }
  
        // show the brand popup now; position already computed in click handler
        this.BrandCollateralList = brands;
      }
  
      this.ShowETAAlternatives = false;
      this.ShowSearchResultsAlternatives = false;
      this.LoadingSideOffers = false;
    });
  }

  SwitchGridResultProduct(SelectedResult:any){

    if(SelectedResult.Price?.UIUnitPrice > 0){
      var request = {
        User:this.parent.User,
        Language:this.parent.getLanguage(),
        PartnerID:this.parent.B2BPartner?.ID,
        SelectedResult:SelectedResult,
        InitialCartItem:this.ClickedRow?.CartItem,
      };
    
      this.LoadingSideOffers = true;
    
      this.B2BService.SwitchGridResultProduct(request).subscribe(response => {
    
        if(response["Status"] != 1){
          // this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
        }
        else if(response["Status"] == 1){
          var c = JSON.parse(JSON.stringify(response["CartItem"]));
          c.LoadingCell = false;
          this.applyCartItemToRow(this.ClickedRowIndex, c);
          this.UpdateCart();
        }
    
        this.ShowETAAlternatives = false;
        this.ShowSearchResultsAlternatives = false;
        this.LoadingSideOffers = false;
        this.ShowFallbackSelection = false;
       });
    }
  }

  // --- Quantity concurrency control ---
private qtyBusy = new Map<string, boolean>();       // rowKey -> in-flight?
private qtyPending = new Map<string, number>();     // rowKey -> latest desired qty while busy
private qtyInFlight = 0;                            // total in-flight qty updates
private qtyCartFlushTimer: any = null;              // coalesce UpdateCart()
private initializeCartSeq = 0;                      // sequence counter to discard stale InitializeCart responses

private getRowKeyForQuantity(rowIndex: number, item: any): string {
  // Prefer persistent UIID from your backend; fall back to rowIndex.
  return item?.UIID || `row-${rowIndex}`;
}

private deferCartUpdateAfterQty(): void {
  if (this.qtyCartFlushTimer) clearTimeout(this.qtyCartFlushTimer);
  // small delay to coalesce completions finishing nearly at once
  this.qtyCartFlushTimer = setTimeout(() => {
    this.qtyCartFlushTimer = null;
    this.UpdateCart();
  }, 150);
}

  private insertedOverflowUIIDs = new Set<string>();

  ChangeGridQuantityVersion2(rowIndex: number, quantity: any, item: any): void {
    // Normalize and validate quantity just once
    const q = Number(quantity);
    if (!Number.isFinite(q)) return;
  
    const rowKey = this.getRowKeyForQuantity(rowIndex, item);
  
    // If this row is already updating, just remember the latest requested qty
    if (this.qtyBusy.get(rowKey)) {
      this.qtyPending.set(rowKey, q); // coalesce to the latest value
      return;
    }
  
    this.qtyBusy.set(rowKey, true);
    this.qtyInFlight++;
  
    // Optional: per-row UI hint
    const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
    if (rowNode?.data?.CartItem) {
      rowNode.data.CartItem.LoadingCell = true;
      this.gridApi.refreshCells({
        rowNodes: [rowNode],
        columns: ['quantity', 'price', 'total', 'eta', 'name'],
        force: true
      });
    }
  
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CartItem: item,
      Quantity: q
    };

    this.loadingProducts = true;
  
    this.B2BService.ChangeGridQuantityVersion2(request)
      .pipe(finalize(() => {
        // Row complete
        this.qtyBusy.delete(rowKey);
        this.qtyInFlight = Math.max(0, this.qtyInFlight - 1);
  
        // If a newer qty was requested during the in-flight call, run it now.
        const pending = this.qtyPending.get(rowKey);
        if (pending !== undefined && pending !== q) {
          this.qtyPending.delete(rowKey);
  
          // Get latest cartItem (may have been replaced by server)
          const latestNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
          const latestItem = latestNode?.data?.CartItem ?? item;
          this.ChangeGridQuantityVersion2(rowIndex, pending, latestItem);
          return; // don't schedule cart update yet; next call will handle it
        }
        this.qtyPending.delete(rowKey);
  
        // When all rows are done, coalesce a single UpdateCart()
        if (this.qtyInFlight === 0) {
          this.deferCartUpdateAfterQty();
        }
      }))
      .subscribe(response => {
        if (response["Status"] !== 1) {
          this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
          if (rowNode?.data?.CartItem) {
            rowNode.data.CartItem.LoadingCell = false;
            this.gridApi.refreshCells({ rowNodes: [rowNode], columns: ['quantity'], force: true });
          }
          return;
        }
  
        // Apply the first returned item (your original behavior)
        const items = JSON.parse(JSON.stringify(response["CartItems"] ?? []));
        const first = items.find(Boolean);
        if (first) {
          this.applyCartItemToRow(rowIndex, first);
        }
      });
  }
  
  
  private applyCartItemToRow(rowIndex: number, cartItem: any): void {
    if (!this.gridApi || !cartItem) return;
  
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    if (!rowNode) return;
  
    const brand = cartItem?.Product?.Brand?.Name ?? '';
    const name = cartItem?.UIProductValue ?? '';
    const partNumber = cartItem?.Product?.PartNumber ?? '';
    const quantity = cartItem?.Quantity ?? '';
  
    // ✅ Price logic: show '' if SellPrice is not > 0, currency is now in header
    const sellPrice = cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice;
    const showPrice = sellPrice > 0;
    const price = showPrice
      ? `${Number(sellPrice).toFixed(2)}`
      : '';

    const total = cartItem?.Price?.UIQtyPrice != null
      ? `${Number(cartItem.Price.UIQtyPrice).toFixed(2)}`
      : '';

    const eta = cartItem?.SelectedOffer?.LeadTime?.UIOutput ?? '------';

    const hscode = cartItem?.Product?.Stats?.HSCode ?? '';
    const coo = cartItem?.Product?.Stats?.COO?.ShortName ?? '';
    const weight = cartItem?.Product?.Stats?.Weight != null
      ? `${cartItem.Product.Stats.Weight} ${cartItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`
      : '';
  
    rowNode.setData({
      index: rowIndex + 1,
      brand,
      partNumber,
      name,
      quantity,
      price,
      total,
      eta,
      hscode,
      coo,
      weight,
      CartItem: JSON.parse(JSON.stringify(cartItem))
    });
  
    // === Overflow logic continues below as-is ===
    const isOverflowNeeded =
      cartItem?.SelectedOffer?.StockOverRequestedQuantity > 0 &&
      !cartItem.IsOverflowRow;
  
    const nextRow = this.gridApi.getDisplayedRowAtIndex(rowIndex + 1);
    const isNextAlreadyOverflow = nextRow?.data?.CartItem?.IsOverflowRow === true;

    this.insertedOverflowUIIDs.clear();
  
    const uiid = cartItem?.UIID;
    if (!isOverflowNeeded || isNextAlreadyOverflow || this.insertedOverflowUIIDs.has(uiid)) {
      this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
      return;
    }
  
    this.insertedOverflowUIIDs.add(uiid);
  
    const clonedCartItem = JSON.parse(JSON.stringify(cartItem));
    clonedCartItem.IsOverflowRow = true;
    clonedCartItem.Quantity = 0;
    clonedCartItem.LoadingCell = true;
  
    const request = {
      User: this.parent.User,
      Language: this.parent.getLanguage(),
      PartnerID: this.parent.B2BPartner?.ID,
      CartItem: clonedCartItem
    };
  
    this.B2BService.GetIndustryProductByStockOverRequestedQuantity(request).subscribe(response => {
      // Check if no other offers are available (outside CartItem check - popup still shows even without CartItem)
      if(response["Status"] === 1 && response["NoOtherOffersAvailable"] == true){
        this.stockReadjustedMessage = response["NoOtherOffersMessage"];
        this.stockReadjustedProducts = [];
        this.showStockReadjustedPopup = true;
      }

      if (response["Status"] === 1 && response["CartItem"]) {
        const overflowItem = JSON.parse(JSON.stringify(response["CartItem"]));
        const overflowUIID = overflowItem?.UIID;
  
        if (!overflowUIID || this.insertedOverflowUIIDs.has(overflowUIID)) return;
        this.insertedOverflowUIIDs.add(overflowUIID);
  
        const newRow = {
          index: rowIndex + 2,
          brand: overflowItem?.Product?.Brand?.Name ?? '',
          partNumber: overflowItem?.Product?.PartNumber ?? '',
          name: overflowItem?.UIProductValue ?? '',
          quantity: overflowItem?.Quantity ?? '',
          price: (overflowItem?.SelectedOffer?.SellPrice?.UIUnitPrice > 0)
            ? `${Number(overflowItem.SelectedOffer.SellPrice.UIUnitPrice).toFixed(2)}`
            : '',
          total: overflowItem?.Price?.UIQtyPrice != null
            ? `${Number(overflowItem.Price.UIQtyPrice).toFixed(2)}`
            : '',
          eta: overflowItem?.SelectedOffer?.LeadTime?.Units > 0
            ? `${overflowItem.SelectedOffer.LeadTime.Units} ${overflowItem.SelectedOffer.LeadTime.Type?.Name ?? ''}`
            : '------',
          hscode: overflowItem?.Product?.Stats?.HSCode ?? '',
          coo: overflowItem?.Product?.Stats?.COO?.ShortName ?? '',
          weight: overflowItem?.Product?.Stats?.Weight != null
            ? `${overflowItem.Product.Stats.Weight} ${overflowItem.Product.Stats.WeightMeasurementType?.Name ?? ''}`
            : '',
          CartItem: overflowItem
        };
  
        this.gridApi.applyTransaction({ add: [newRow], addIndex: rowIndex + 1 });
        this.parent.Cart.Items.splice(rowIndex + 1, 0, overflowItem);
        localStorage.setItem("Cart", JSON.stringify(this.parent.Cart));

        // Invalidate any in-flight InitializeCart — its response was built without this overflow item
        this.initializeCartSeq++;
      } else {
        clonedCartItem.LoadingCell = false;
        this.parent.openSnackBar(response["Message"] ?? "Overflow error", "OK", "alert-info-snackbar");
      }
    });
  
    this.gridApi.refreshCells({ rowNodes: [rowNode], force: true });
  }
  
  
  exportToExcel(): void {
   
  }

  onCellClicked: (event: any) => {
   
  }
  
   /** Parse numbers for quantity */
   numberParser(params: any): number {
    const val = Number(params.newValue);
    return isNaN(val) ? params.oldValue : val;
  }

  /** Format decimal values for price/total */
  decimalFormatter(params: any): string {
    return params.value != null ? parseFloat(params.value).toFixed(2) : '';
  }
  
  SelectedCartItem:any;

  SelectGridItem(item:any){
    this.SelectedCartItem = JSON.parse(JSON.stringify(item));
  }

  Filter: {[k: string]: any} = {};

  InitializeFilter(){

  this.Filter = {};
  this.Filter.SearchTerm = "";

  this.Filter.Pager = {};
  this.Filter.Pager.PageIndex = 1;
  this.Filter.Pager.PageSize = 50;
  this.Filter.Pager.TotalCount = 0;

  this.Filter.Company = {};
  this.Filter.Company = null;

  this.Filter.Brand = {};
  this.Filter.Brand = null;

  this.Filter.ProductBoxStatus = {};
  this.Filter.ProductBoxStatus = null;

  this.Filter.ProductConditionStatus = {};
  this.Filter.ProductConditionStatus = null;

  this.Filter.ProductManufacturingStatus = {};
  this.Filter.ProductManufacturingStatus = null;

  this.Filter.ProductVersionStatus = {};
  this.Filter.ProductVersionStatus = null;

  this.Filter.Creator = {};
  this.Filter.Creator = null;

  this.Filter.Updater = {};
  this.Filter.Updater = null;

  this.Filter.CombineProductsByID = true;
}



ShowSearchProductsPageMessage:boolean;

loadingProducts:boolean;
SearchedProducts:any[];
CartItemRows: {[k: string]: any} = [];

InitializeSearchProduct(item:any){

  this.CurrentCartItemRow = item;
  this.SelectItem(item);

  if((this.SearchedProducts == null || this.SearchedProducts.length == 0) && this.Filter.SearchTerm?.length > 2){
    this.SearchIndustryProducts();
  }
}

OfferPriorityStatuses:any[];
OfferPriorityStatus:any;

PopulateCartItems(rows = 50){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Rows:rows
  };

  this.loadingProducts = true;

  this.B2BService.PopulateCartItems(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var CI = JSON.parse(JSON.stringify(response["CartItems"]));
      this.CartItemRows = this.CartItemRows.concat(CI);

      if(this.OfferPriorityStatuses == null || this.OfferPriorityStatuses?.length == 0){
        this.OfferPriorityStatuses = response["OfferPriorityStatuses"];
        this.OfferPriorityStatus = this.OfferPriorityStatuses[0];
      }
    }

    this.loadingProducts = false;
   });
}

GetIndustryProductsStocksFiltered(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.GetIndustryProductsStocksFiltered(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["StockProducts"];
    }

    this.loadingProducts = false;
   });
}

AllSelected:boolean;

SelectAll(){
  this.parent.Cart.Items.forEach(r => {
    r.IsSelected = this.AllSelected;
  });

  this.CheckIfAnyChecked();
}

AnyChecked:boolean;

CheckIfAnyChecked(){
  this.AnyChecked = false;

  this.parent.Cart.Items.forEach(element => {
    if(element.IsSelected){
      this.AnyChecked = true;
    }
  });
}

SearchIndustryProducts(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Filter:this.Filter
  };

  this.loadingProducts = true;

  this.managementService.SearchIndustryProducts(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.SearchedProducts = response["SearchResults"];
    }

    this.loadingProducts = false;
   });
}

SelectItem(i:any){
  this.CartItemRows.forEach(cell => {
    if(cell.UIID == i.UIID){
      cell.IsSelected = !cell.IsSelected;
    }
    else{
      cell.IsSelected = false;
    }
  });
}

SplitGetIndustryProductsSearchQuery(searchQuery:string){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    SearchQuery:searchQuery,
    UIID:this.CurrentCartItemRow.UIID,
    CartItems:this.CartItemRows,
    Partner:this.parent.B2BPartner
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == this.CurrentCartItemRow.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SplitGetIndustryProductsSearchQuery(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.CartItemRows = [];
      this.CartItemRows = JSON.parse(JSON.stringify(response["CartItems"]));

      this.CartItemRows.filter(x => !x.WasSearchedFor && x.UIProductValue?.length > 0).forEach(cell => {
        this.SearchIndustryProductsFromGridCell(cell);
      });
    }

    this.searchTermUpdate.next(null);
   });
}

SearchIndustryProductsFromGridCell(item:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    UIID:item.UIID,
    CartItem:item,
  };

  this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = true;
      }
  });

  this.B2BService.SearchIndustryProductsFromGridCell(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["CartItem"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == item.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
            this.GetGridCellItemData(JSON.parse(JSON.stringify(this.CartItemRows[index])));
        }
      });
    }

    this.CartItemRows.forEach(cell => {
      if(cell.UIID == item.UIID){
        cell.LoadingCell = false;
      }
    });

    this.searchTermUpdate.next(null);
   });
}

SelectGridSearchResult(s:any, item:any){

  item.SearchResults.forEach(element => {
    element.IsSelected = false;
  });

  // Find the index of the matching search result
const index = item.SearchResults.findIndex(searchResult => searchResult.UIID === s.UIID);

// If a matching search result is found
if (index !== -1) {
    // Set isSelected to true
    item.SearchResults[index].IsSelected = true;

    // Move the matching search result to the beginning of the array
    const selectedSearchResult = item.SearchResults.splice(index, 1)[0];
    item.SearchResults.unshift(selectedSearchResult);
}

  this.GetGridCellItemData(JSON.parse(JSON.stringify(item)));
  item.IsSelected = false;
}

GetGridCellItemData(c:any){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    newItem:c,
    Partner:this.parent.B2BPartner
  };

  this.B2BService.GetGridCellItemData(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){

      var Item = response["Item"];

      this.CartItemRows.forEach((cell, index) => {
        if(cell.UIID == c.UIID){
            this.CartItemRows[index] = JSON.parse(JSON.stringify(Item));
        }
    });
    }
   });
}

// Helper: collect CartItems from the visible grid rows
private getCartItemsFromGrid(): any[] {
  const items: any[] = [];
  if (!this.gridApi) return items;

  this.gridApi.forEachNode((node) => {
    const ci = node?.data?.CartItem;
    // push only meaningful cart items
    if (ci && typeof ci === 'object' && Object.keys(ci).length > 0) {
      const clonedItem = JSON.parse(JSON.stringify(ci)); // deep copy to avoid accidental mutation
      clonedItem.Index = (node.rowIndex ?? 0) + 1; // ✅ Set Index to 1-based row position for correct PDF ordering
      items.push(clonedItem);
    }
  });

  return items;
}

  // More specific version with error handling
  downloadExcel = (filename: string, base64Data: string): boolean => {
    try {
      // Validate inputs
      if (!filename || !base64Data) {
        console.error('Filename and base64 data are required');
        return false;
      }
      
      // Ensure filename has .xlsx extension
      const finalFilename = filename.endsWith('.xlsx') ? filename : `${filename}.xlsx`;
      
      const element = document.createElement('a');
      const dataUrl = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64Data}`;
      
      element.href = dataUrl;
      element.download = finalFilename;
      element.style.display = 'none';
      
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      
      return true;
    } catch (error) {
      console.error('Download failed:', error);
      return false;
    }
  };

ExportB2BGrid(){

  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    CartItems:this.getCartItemsFromGrid(),
  };

  this.parent.loading = true;
  this.loadingProducts = true;

  this.B2BService.ExportB2BGrid(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      var Document = response["Document"];
      this.downloadExcel(Document.Name, Document.PDFStream);

      // ✅ Track Excel export event
      this.TrackB2BUserGridEvent(5); // eB2BUserTrackingEventType.ExportXLSX
    }
   });

   this.parent.loading = false;
   this.loadingProducts = false;
}

download(filename, text) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:application/pdf;base64,' + encodeURIComponent(text));
  element.setAttribute('download', filename);

  element.style.display = 'none';
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
}

/** Returns true when at least one valid cart-item's SelectedOffer is a partner-stock offer */
get hasPartnerStockItems(): boolean {
  return this.parent.Cart?.Items?.some((i: any) =>
    i?.CartItemStatus?.ID === 1 && i?.SelectedOffer?.IsPartnerStock === true
  ) ?? false;
}

ShowAllProductsDetails:boolean = false;

ShowAllProductsDetailsFunction(e:boolean){
  this.ShowAllProductsDetails = e;
  this.parent.Cart.Items.forEach(element => {
    element.Product.ShowDetails = e;
  });
}

CloseShowSearchProductsPageMessage(){
  this.cookieService.set("SearchProductsPageMessage", "true");
  this.ShowSearchProductsPageMessage = false;
}

B2BHomePageMessage:string;

GetB2BHomePageMessage(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
    Partner:this.parent.B2BPartner,
    Agent:this.parent.B2BAgent
  };

  this.loadingProducts = true;

  this.B2BService.GetB2BHomePageMessage(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.ShowSearchProductsPageMessage = true;
      this.B2BHomePageMessage = response["B2BHomePageMessage"];
      this.GetB2BListedBrands();
    }

    this.loadingProducts = false;
   });
}

Brands:any[];
loadingBrandIcons:boolean = false;

GetB2BListedBrands(){
    
  var request = {
    User:this.parent.User,
    Language:this.parent.getLanguage(),
  };

  this.loadingBrandIcons = true;

  this.B2BService.GetB2BListedBrands(request).subscribe(response => {

    if(response["Status"] != 1){
      this.parent.openSnackBar(response["Message"], "OK", "alert-info-snackbar");
    }
    else if(response["Status"] == 1){
      this.Brands = JSON.parse(JSON.stringify(response["Brands"]));
    }

    this.loadingBrandIcons = false;
   });
}

InitializeBrandFilter(){
  this.BrandFilter = {};
  this.BrandFilter.SearchTerm = "";
  this.BrandFilter.Pager = {};
  this.BrandFilter.Pager.PageIndex = 1;
  this.BrandFilter.Pager.PageSize = 50;
  this.BrandFilter.Pager.TotalCount = 0;
}

BrandsLoading:boolean = false;
BrandFilter: {[k: string]: any} = {};
ShowBrandCollateralNewProduct:boolean = false;

AttachBrandToNewProduct(b: any) {
  // 1) Get the live row node (avoid using a stale copy from ClickedRow)
  const rn = this.gridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
  if (!rn) {
    return;
  }

  // 2) Current row data & cart item
  const current = rn.data || {};
  const cartItem = current.CartItem || {};

  // 3) Update CartItem product info
  cartItem.Product = cartItem.Product || {};
  cartItem.Product.Brand = JSON.parse(JSON.stringify(b));

  // Take UI text from the Name cell as product name if available
  const uiValue = (cartItem.UIProductValue ?? current.name ?? '').toString().trim();
  cartItem.UIProductValue = uiValue;                 // keep UI value in sync
  cartItem.Product.Name = uiValue;                   // show same as product name

  // 4) Update the TOP-LEVEL fields used by your columnDefs
  const newBrandName = b?.Name ?? b?.name ?? '';
  const updatedRow = {
    ...current,
    brand: newBrandName,                              // <-- this is what Brand column displays
    name: uiValue,                                    // <-- Name column displays this
    CartItem: JSON.parse(JSON.stringify(cartItem))    // deep copy to avoid ref issues
  };

  // 5) Apply to the grid row (cheap, no full rebind)
  rn.setData(updatedRow);

  // 6) Refresh just what’s needed
  this.gridApi.refreshCells({
    rowNodes: [rn],
    columns: ['brand', 'name'],   // must match your colDef.field values
    force: true
  });
  this.gridApi.redrawRows({ rowNodes: [rn] });

  // 7) Persist to Cart + localStorage (so a later full refresh matches the UI)
  if (this.parent.Cart?.Items) {
    this.parent.Cart.Items[this.ClickedRowIndex] = JSON.parse(JSON.stringify(cartItem));
    localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
  }

  // 8) (Optional) If you want server-side normalization now, keep UpdateCart();
  //    It will re-run InitializeCart and re-render the whole grid.
  //    If you want only immediate local UI, you can remove the next line.
  this.UpdateCart();

  // 9) Close popup
  this.ShowBrandCollateralNewProduct = false;
}

NewProductBrandsList:any[];

GetBrandsFilteredWithSuggestion(searchTerm: string, page = 1, implicitProduct: string = null) {
  // keep filter values in sync
  this.BrandFilter.Pager.PageIndex = page;
  this.BrandFilter.SearchTerm = searchTerm ?? '';

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Filter: this.BrandFilter,
    Product: implicitProduct ?? null
  };

  this.LoadingSideOffers = true;

  this.managementService.GetBrandsFilteredWithSuggestion(request).subscribe(response => {
    try {
      if (response['Status'] !== 1) {
        this.parent.openSnackBar(response['Message'], 'OK', 'alert-info-snackbar');
        return;
      }

      // 1) Update source-of-truth list
      this.NewProductBrandsList = response['Brands'] ?? [];

      // 2) If we’re in a grid context (we set ClickedRowIndex on click), mirror to the row
      if (typeof this.ClickedRowIndex === 'number') {
        const rowNode = this.gridApi?.getDisplayedRowAtIndex(this.ClickedRowIndex);
        if (rowNode?.data) {
          const ci = rowNode.data.CartItem ?? (rowNode.data.CartItem = {});
          ci.CollateralBrands = JSON.parse(JSON.stringify(this.NewProductBrandsList));

          // persist to Cart + localStorage if available
          if (this.parent.Cart?.Items?.[this.ClickedRowIndex]) {
            this.parent.Cart.Items[this.ClickedRowIndex].CollateralBrands = JSON.parse(JSON.stringify(this.NewProductBrandsList));
            localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));
          }

          // refresh only the brand cell (button state remains consistent)
          this.gridApi.refreshCells({
            rowNodes: [rowNode],
            columns: ['brand'],
            force: true
          });
        }
      }

      // 3) Feed the popup with the SAME model used elsewhere
      this.BrandSelectList = JSON.parse(JSON.stringify(this.Brands));
      this.ShowBrandCollateralNewProduct = true;    // ensure opened (in case it was closed)
    }
    finally {
      this.LoadingSideOffers = false;
    }
  });
}

onSelectSearchResultAlternative(s:any){
  s.Loading = true;
}

addMoreRows(count: number = 50): void {
  if (!this.gridApi) return;

  const currentCount = this.gridApi.getDisplayedRowCount();
  const newRows: any[] = [];

  for (let i = 0; i < count; i++) {
    const row = {
      index: currentCount + i + 1,
      brand: '',
      partNumber: '',
      name: '',
      quantity: null,
      price: null,
      total: null,
      eta: '',
      hscode: '',
      coo: '',
      weight: '',
      CartItem: {}
    };

    this.CartItemRows.push(row);     // if you still need it for logic
    newRows.push(row);
  }

  // 🔥 THIS is what updates the grid
  this.gridApi.applyTransaction({ add: newRows });
  console.log('✅ Adding rows:', newRows.length);
}

ClearGridQuestion:boolean;

AskClearGridQuestion(){
  this.ClearGridQuestion = true;
}

ClearGrid(): void {
  const updatedRows: any[] = [];

  this.gridApi.forEachNode((_, index) => {
    updatedRows.push({
      index: index + 1,
      brand: '',
      partNumber: '',
      name: '',
      quantity: null,
      price: null,
      total: null,
      eta: '',
      hscode: '',
      coo: '',
      weight: '',
      CartItem: {}
    });
  });

  this.gridApi.setRowData(updatedRows);

  // ✅ Reset GridID and delete tracking data from localStorage (fresh start for new grid)
  this.resetGridID();
  localStorage.removeItem('B2BUserTracking');
  console.log('🧹 Grid fully cleared, cart emptied, GridID and tracking data deleted.');

  this.UpdateCart();
}

GetCart(): void {
  const storedCart = localStorage.getItem("Cart");
  if (!storedCart) return;

  this.parent.Cart = JSON.parse(storedCart);

  const items = this.parent.Cart?.Items ?? [];
  const rows = items.map((cartItem, index) => {
    const product = cartItem?.Product ?? {};
    const stats = product?.Stats ?? {};
    const price = cartItem?.Price ?? {};
    const leadTime = cartItem?.SelectedOffer?.LeadTime;

    const eta = leadTime?.Units && leadTime.Units > 0
      ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}`
      : '------';

    return {
      index: index + 1,
      brand: product?.Brand?.Name ?? '',
      partNumber: product?.PartNumber ?? '',
      name: cartItem?.UIProductValue ?? '',
      quantity: cartItem?.Quantity ?? null,
      price: price?.UIUnitPrice != null
        ? `${Number(price.UIUnitPrice).toFixed(2)}`
        : '',
      total: price?.UIQtyPrice != null
        ? `${Number(price.UIQtyPrice).toFixed(2)}`
        : '',
      eta,
      hscode: stats?.HSCode ?? '',
      coo: stats?.COO?.ShortName ?? '',
      weight: stats?.Weight != null
        ? `${stats.Weight} ${stats.WeightMeasurementType?.Name ?? ''}` : '',
      CartItem: JSON.parse(JSON.stringify(cartItem))
    };
  });

  this.gridApi.setRowData(rows);
  console.log(`🛒 Loaded ${rows.length} items into the grid from localStorage.`);
}

deliveryPreferences: any[] = [
  { value: 1, label: 'Standard' },
  { value: 2, label: 'Express' },
  { value: 3, label: 'Pickup' }
];

selectedPref: any;

UpdateCart(){
  const items: any[] = [];

  // Loop over all displayed rows in AG Grid
  this.gridApi.forEachNode((node) => {
    const cartItem = node.data?.CartItem;
    if (cartItem) {
      const clonedItem = JSON.parse(JSON.stringify(cartItem)); // deep copy to avoid reference issues
      clonedItem.Index = (node.rowIndex ?? 0) + 1; // ✅ Set Index to 1-based row position for correct PDF ordering
      items.push(clonedItem);
    }
  });

  this.parent.Cart.Items = items;

  // ✅ Check if grid is effectively empty (no rows with CartItem information)
  if (items.length === 0) {
    this.resetGridID();
    localStorage.removeItem('B2BUserTracking');
    console.log('🔄 Grid is empty - GridID and tracking data reset');
  }

  this.InitializeCart();
}

// GridID management for tracking
private getOrCreateGridID(): string {
  const storageKey = 'B2BGridID';
  let gridID = localStorage.getItem(storageKey);

  if (!gridID || gridID.length < 35) {
    // Generate new unique GridID (35-50 characters)
    gridID = this.generateUniqueGridID();
    localStorage.setItem(storageKey, gridID);
  }

  return gridID;
}

private generateUniqueGridID(): string {
  // Generate a unique 40-character ID
  const timestamp = Date.now().toString(36);
  const randomPart = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  const userPart = this.parent.User?.Id?.substring(0, 8) || 'guest';
  return `${timestamp}-${randomPart}-${userPart}`.substring(0, 45);
}

private resetGridID(): void {
  localStorage.removeItem('B2BGridID');
}

// Track B2B User Grid Event
TrackB2BUserGridEvent(eventTypeID: number): void {
  const gridID = this.getOrCreateGridID();

  // ✅ Get previously stored tracking data from localStorage
  let storedTracking: any = null;
  try {
    const storedData = localStorage.getItem('B2BUserTracking');
    if (storedData) {
      storedTracking = JSON.parse(storedData);
    }
  } catch (e) {
    console.warn('Could not parse stored tracking data:', e);
  }

  // Collect all grid lines
  const lines: any[] = [];

  this.gridApi.forEachNode((node) => {
    const data = node.data;
    const cartItem = data?.CartItem;

    // Only include rows with meaningful data
    if (data && (data.name || data.partNumber || data.brand)) {
      const gridIndex = node.rowIndex + 1; // 1-based index

      // ✅ Find existing line ID from localStorage based on GridIndex
      let existingLineID = 0; // 0 = insert new, >0 = update existing
      if (storedTracking?.Lines && Array.isArray(storedTracking.Lines)) {
        const existingLine = storedTracking.Lines.find((l: any) => l.GridIndex === gridIndex);
        if (existingLine?.ID) {
          existingLineID = existingLine.ID;
        }
      }

      const line = {
        ID: existingLineID, // ✅ Include database ID (0 for new, existing ID for update)
        GridIndex: gridIndex,
        Brand: data.brand || '',
        PartNumber: data.partNumber || '',
        Name: data.name || '',
        Qty: cartItem?.Quantity || 0,
        ListPrice: this.extractNumericValue(cartItem?.Product?.Stats?.StandardListPrice?.UIUnitPrice),
        Discount: cartItem?.Product?.Stats?.StandardListPrice?.Discount?.Value || null,
        FinalPrice: this.extractNumericValue(cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice),
        Total: this.extractNumericValue(cartItem?.Price?.UIQtyPrice),
        StandardDelivery: data.eta || '',
        HSCode: data.hscode || '',
        COO: data.coo || '',
        Weight: data.weight || '',
        DatasheetLink: cartItem?.Product?.Stats?.DatasheetLink || '',
        BrandID: cartItem?.Product?.Brand?.ID || null
        // ParentEventID, EventRegister, EventRegisterUI - handled by backend
      };

      lines.push(line);
    }
  });

  // Find the event type from parent
  const eventType = this.parent.B2BUserTrackingEventTypes?.find(e => e.ID === eventTypeID);

  // ✅ Get existing EventID from localStorage (0 for new, existing ID for update)
  let existingEventID = 0;
  if (storedTracking?.EventID) {
    existingEventID = storedTracking.EventID;
  }

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Partner: this.parent.B2BPartner,
    B2BUserTracking: {
      EventID: existingEventID, // ✅ 0 = insert new event, >0 = update existing
      EventType: eventType || { ID: eventTypeID, Name: '' },
      EventRegister: new Date(),
      EventRegisterUI: new Date().toISOString(),
      IncomingURL: window.location.href,
      PartnerID: this.parent.B2BPartner?.ID?.toString() || '',
      PartnerName: this.parent.B2BPartner?.Name || '',
      IncomingUserID: this.parent.User?.Id || '',
      IncomingEmailAddress: this.parent.User?.Email || '',
      Status: 1,
      GridID: gridID,
      Lines: lines,
      CurrencyID: this.parent.Cart?.Currency?.ID || 2
      // IncomingCountryCode, IncomingIPAddress, IncomingAddressDetails - populated by backend
    }
  };

  // Send tracking request
  this.B2BService.B2BRUTE(request).subscribe(response => {
    if (response["Status"] === 1) {
      console.log('✅ Grid event tracked successfully:', eventType?.Name, lines.length, 'rows');

      // ✅ Store the backend response with database-generated IDs in localStorage
      if (response["B2BUserTracking"]) {
        const trackingData = response["B2BUserTracking"];
        localStorage.setItem('B2BUserTracking', JSON.stringify(trackingData));
        console.log('💾 Stored tracking data with EventID:', trackingData.EventID);
      }
    } else {
      console.warn('⚠️ Grid event tracking failed:', response["Message"]);
    }
  });
}

// ═══════════════════════════════════════════════════════════════
// Screenshot detection — tracks PrintScreen, SnippingTool, Mac, Print
// ScreenshotType: 1=PrintScreen, 2=SnippingTool, 3=MacScreenshot, 4=PrintPage, 5=WinSnipAndSketch
// ═══════════════════════════════════════════════════════════════

private screenshotThrottleTimer: any = null;

@HostListener('window:keyup', ['$event'])
onScreenshotKeyUp(event: KeyboardEvent): void {
  // PrintScreen — browsers fire keyup, NOT keydown for this key on Windows
  if (event.key === 'PrintScreen') {
    this.trackScreenshotEvent(1); // PrintScreen
    return;
  }
}

@HostListener('window:keydown', ['$event'])
onScreenshotKeyDown(event: KeyboardEvent): void {
  // Ctrl+Shift+S — Windows Snipping Tool
  if (event.ctrlKey && event.shiftKey && event.key === 'S') {
    this.trackScreenshotEvent(2); // SnippingTool
    return;
  }

  // Cmd+Shift+3 or Cmd+Shift+4 or Cmd+Shift+5 — Mac screenshots
  if (event.metaKey && event.shiftKey && ['3', '4', '5'].includes(event.key)) {
    this.trackScreenshotEvent(3); // MacScreenshot
    return;
  }

  // Ctrl+P — Print page (could be Save as PDF)
  if (event.ctrlKey && event.key === 'p') {
    this.trackScreenshotEvent(4); // PrintPage
    return;
  }

  // Cmd+P — Print page (Mac)
  if (event.metaKey && event.key === 'p') {
    this.trackScreenshotEvent(4); // PrintPage
    return;
  }
}

@HostListener('window:beforeprint')
onBeforePrint(): void {
  this.trackScreenshotEvent(4); // PrintPage
}

private trackScreenshotEvent(screenshotType: number): void {
  // Throttle: only send once per 3 seconds to avoid duplicates
  if (this.screenshotThrottleTimer) return;
  this.screenshotThrottleTimer = setTimeout(() => {
    this.screenshotThrottleTimer = null;
  }, 3000);

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Screenshot: {
      PartnerID: this.parent.B2BPartner?.ID?.toString() || '',
      PartnerName: this.parent.B2BPartner?.Name || '',
      UserID: this.parent.User?.Id || '',
      UserEmail: this.parent.User?.Email || '',
      ScreenshotType: { ID: screenshotType, Name: '' },
      IncomingURL: window.location.href,
      ParentGridID: this.getOrCreateGridID()
    }
  };

  this.B2BService.AddB2BTrackingScreenshot(request).subscribe(response => {
    if (response["Status"] === 1) {
      console.log('📸 Screenshot event tracked:', screenshotType);
    }
  });
}

// Helper to extract numeric values from formatted strings
private extractNumericValue(value: any): number | null {
  if (value == null) return null;
  if (typeof value === 'number') return value;
  if (typeof value === 'string') {
    const numStr = value.replace(/[^\d.-]/g, '');
    const num = parseFloat(numStr);
    return isNaN(num) ? null : num;
  }
  return null;
}

InitializeCart(): void {
  // ✅ Client-side cart initialization — no server round-trip needed
  // All logic from backend InitializeCart (B2BBL.cs) is replicated in cart-initializer.util.ts
  const result = initializeCartLocal(
    this.parent.Cart,
    this.parent.B2BPartner,
    this.parent.CartMasterData,
    this.parent.User
  );

  this.parent.Cart = result.cart;
  this.parent.CartMasterData = result.masterData;
  const hasChanges = result.hasChanges;

  // ✅ Check if stock was readjusted and show popup
  if (result.stockWasReadjusted) {
    this.stockReadjustedMessage = result.stockReadjustedMessage || 'Some quantities were adjusted due to stock limits.';
    this.stockReadjustedProducts = result.stockReadjustedProducts || [];
    this.showStockReadjustedPopup = true;
  }

  localStorage.setItem('Cart', JSON.stringify(this.parent.Cart));

  // ✅ Update column headers with currency symbol
  this.updateColumnHeaders();

  if (hasChanges && this.gridApi) {
    const items = this.parent.Cart?.Items ?? [];

    const rows = items.map((cartItem, index) => {
      const product = cartItem?.Product ?? {};
      const stats = product?.Stats ?? {};
      const leadTime = cartItem?.SelectedOffer?.LeadTime ?? {};
      const priceInfo = cartItem?.Price ?? {};

      const sellPrice = cartItem?.SelectedOffer?.SellPrice?.UIUnitPrice;
      // ✅ show '' when sell price <= 0, currency is now in header
      const price =
        sellPrice > 0 ? `${Number(sellPrice).toFixed(2)}` : '';

      const total =
        priceInfo?.UIQtyPrice != null
          ? `${Number(priceInfo.UIQtyPrice).toFixed(2)}`
          : '';

      const eta =
        leadTime?.Units > 0
          ? `${leadTime.Units} ${leadTime.Type?.Name ?? ''}`
          : '------';

      return {
        index: index + 1,
        brand: product?.Brand?.Name ?? '',
        partNumber: product?.PartNumber ?? '',
        name: cartItem?.UIProductValue ?? '',
        quantity: cartItem?.Quantity ?? null,
        price,
        total,
        eta,
        hscode: stats?.HSCode ?? '',
        coo: stats?.COO?.ShortName ?? '',
        weight:
          stats?.Weight != null
            ? `${stats.Weight} ${stats?.WeightMeasurementType?.Name ?? ''}`
            : '',
        CartItem: JSON.parse(JSON.stringify(cartItem))
      };
    });

    this.gridApi.setRowData(rows);
    console.log(`🔁 Grid re-rendered due to cart changes (${rows.length} rows).`);
  }

  this.loadingProducts = false;
  this.parent.loading = false;
}

// ✅ Initialize selected agents and shipping address from last offer request
InitializeAgentsAndShippingAddress() {
  // ✅ Check if partner is selected
  if (!this.parent.B2BPartner?.ID) {
    this.selectedAgents = [];
    this.parent.OfferRequest.ShippingAddress = null;
    return;
  }

  // ✅ Call backend to get last selected agents and address from previous offer request
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    PartnerID: this.parent.B2BPartner.ID
  };

  this.parent.loading = true;

  this.B2BService.GetOfferLastSelectedAgentsAndAddressByPartnerID(request).subscribe((response: any) => {
    this.parent.loading = false;

    if (response["Status"] !== 1) {
      // ✅ If error or no previous offer request, fall back to default selection
      this.fallbackToDefaultSelection();
      return;
    }

    // ✅ Pre-select agents from last offer request (if any matched)
    if (response["LastSelectedPartnerAgents"] && response["LastSelectedPartnerAgents"].length > 0) {
      this.selectedAgents = response["LastSelectedPartnerAgents"];
    } else {
      // ✅ No agents matched - fall back to agents with IsSelected == true
      this.fallbackToDefaultAgentSelection();
    }

    // ✅ Load default notification phases for all selected agents
    this.loadDefaultPhasesForSelectedAgents();

    // ✅ Pre-select shipping address from last offer request (if matched)
    if (response["LastSelectedShippingAddress"]) {
      this.parent.OfferRequest.ShippingAddress = response["LastSelectedShippingAddress"];
    } else {
      // ✅ No address matched - fall back to default selection
      this.fallbackToDefaultAddressSelection();
    }

    // ✅ Validate the selected address after initialization
    this.checkAndOpenMandatoryAddressModal();
  }, (error: any) => {
    this.parent.loading = false;
    console.error('Error getting last selected agents and address:', error);
    // ✅ On error, fall back to default selection
    this.fallbackToDefaultSelection();
    // ✅ Validate after fallback
    this.checkAndOpenMandatoryAddressModal();
  });
}

// ✅ Fallback to default selection (agents with IsSelected == true, first address)
fallbackToDefaultSelection() {
  this.fallbackToDefaultAgentSelection();
  this.fallbackToDefaultAddressSelection();
  this.loadDefaultPhasesForSelectedAgents();
}

// ✅ Fallback to default agent selection (agents with IsSelected == true)
fallbackToDefaultAgentSelection() {
  if (this.parent.B2BPartner?.PartnerAgents) {
    this.selectedAgents = this.parent.B2BPartner.PartnerAgents.filter((a: any) => a.IsSelected === true);
  } else {
    this.selectedAgents = [];
  }
}

// ✅ Load default notification phases for all agents (selected + all partner agents)
loadDefaultPhasesForSelectedAgents(): void {
  const allAgents = this.parent.B2BPartner?.PartnerAgents || [];
  allAgents.forEach((agent: any) => {
    if (agent.ID > 0) {
      const req = {
        User: this.parent.User,
        Language: this.parent.getLanguage(),
        AgentID: agent.ID
      };
      this.service.GetPartnerAgentDefaultPhases(req).subscribe((res: any) => {
        if (res.Status === 1) {
          agent.OrderPhases = res.Phases || [];
          // Also sync on selectedAgents reference
          const selected = this.selectedAgents?.find((a: any) => a.ID === agent.ID);
          if (selected) {
            selected.OrderPhases = agent.OrderPhases;
          }
        }
      });
    }
  });
}

// ✅ Fallback to default address selection (first address or address with IsSelected == true)
fallbackToDefaultAddressSelection() {
  if (this.parent.B2BPartner?.ShippingAddresses && this.parent.B2BPartner.ShippingAddresses.length > 0) {
    // Try to find address with IsSelected == true
    const selectedAddress = this.parent.B2BPartner.ShippingAddresses.find((a: any) => a.IsSelected === true);
    this.parent.OfferRequest.ShippingAddress = selectedAddress || this.parent.B2BPartner.ShippingAddresses[0];
  } else {
    this.parent.OfferRequest.ShippingAddress = null;
  }
}

/**
 * Get Offer Request Master Data (OrderConsolidationTypes, OrderDeliveryPreferences)
 */
GetOfferMasterData() {
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
  };

  this.B2BService.GetOfferMasterData(request).subscribe(response => {
    if (response["Status"] === 1) {
      this.OfferRequestMasterData = response;

      // ✅ Pre-select "Consolidated" (ID = -1) as default
      if (this.OfferRequestMasterData["OrderConsolidationTypes"]) {
        const consolidated = this.OfferRequestMasterData["OrderConsolidationTypes"].find((t: any) => t.ID === -1);
        if (consolidated) {
          this.parent.OfferRequest.ConsolidationType = consolidated;
        }
      }

      // ✅ Pre-select "PartialDelivery" (ID = -1) as default
      if (this.OfferRequestMasterData["OrderDeliveryPreferences"]) {
        const partialDelivery = this.OfferRequestMasterData["OrderDeliveryPreferences"].find((d: any) => d.ID === -1);
        if (partialDelivery) {
          this.parent.Cart.DeliveryPreference = partialDelivery;
        }
      }

      console.log('✅ Offer Request Master Data loaded. OrderConsolidationTypes:', this.OfferRequestMasterData["OrderConsolidationTypes"]);
    }
  });
}

// ✅ Detected Product Popup Methods (for invalid items - CartItemStatus.ID === 0)
// Store UIProductValue from row for fallback when no product detected
DetectedProductUIProductValue: string = '';

OpenDetectedProductPopup(rowIndex: number, searchTerm: string) {
  this.DetectedProductRowIndex = rowIndex;
  this.DetectedProductSearchTerm = searchTerm;
  this.DetectedProductData = null;
  this.LoadingDetectedProduct = true;
  this.ShowDetectedProductPopup = true;

  // Get the row data to check if user has selected a brand
  const rowNode = this.gridApi?.getDisplayedRowAtIndex(rowIndex);
  const cartItem = rowNode?.data?.CartItem;
  const brandId = cartItem?.Product?.Brand?.ID > 0 ? cartItem.Product.Brand.ID : null;

  // Store UIProductValue for fallback when no product is detected
  this.DetectedProductUIProductValue = cartItem?.UIProductValue || '';

  // Call the API to get B2B offers with master data
  this.SearchIndustryProductB2BOffersExactMatchWithMasterData(searchTerm, brandId);
}

CloseDetectedProductPopup() {
  this.ShowDetectedProductPopup = false;
  this.DetectedProductData = null;
  this.LoadingDetectedProduct = false;
  this.DetectedProductRowIndex = -1;
  this.DetectedProductSearchTerm = '';
  this.DetectedProductUIProductValue = '';
  this.InitializeDetectedProductBrandSearch();
  // Reset Ask Price & Delivery state
  this.LoadingAskPriceDelivery = false;
  this.AskPriceDeliveryError = '';
  this.AskPriceDeliverySuccess = false;
}

// ✅ Duplicate Order Popup Methods
CloseDuplicateOrderPopup() {
  this.parent.ShowDuplicateOrderPopup = false;
  this.parent.DuplicateOfferRequest = null;
  // Close the original send popup as well
  this.AskAddNewRFQasPOQuestion = false;
  this.AskAddNewRFQQuestion = false;
}

// ✅ Resend Order PIN Confirmation Properties
ShowResendPINPopup: boolean = false;
GeneratedPIN: string[] = ['0', '0', '0', '0'];
EnteredPIN: string[] = ['', '', '', ''];
PINMismatchError: boolean = false;

OpenResendOrderPINPopup() {
  // Generate random 4-digit PIN
  this.GeneratedPIN = [
    Math.floor(Math.random() * 10).toString(),
    Math.floor(Math.random() * 10).toString(),
    Math.floor(Math.random() * 10).toString(),
    Math.floor(Math.random() * 10).toString()
  ];
  // Reset entered PIN
  this.EnteredPIN = ['', '', '', ''];
  this.PINMismatchError = false;
  this.ShowResendPINPopup = true;
}

CloseResendPINPopup() {
  this.ShowResendPINPopup = false;
  this.GeneratedPIN = ['0', '0', '0', '0'];
  this.EnteredPIN = ['', '', '', ''];
  this.PINMismatchError = false;
}

onPINInput(event: any, index: number) {
  const value = event.target.value;
  // Only allow digits
  if (!/^\d*$/.test(value)) {
    this.EnteredPIN[index] = '';
    return;
  }
  // Auto-focus next input
  if (value.length === 1 && index < 3) {
    const nextInput = document.querySelector(`input.PINBox.input:nth-of-type(${index + 2})`) as HTMLInputElement;
    if (nextInput) {
      nextInput.focus();
    }
  }
}

onPINKeydown(event: KeyboardEvent, index: number) {
  // Handle backspace to go to previous input
  if (event.key === 'Backspace' && this.EnteredPIN[index] === '' && index > 0) {
    const prevInput = document.querySelector(`input.PINBox.input:nth-of-type(${index})`) as HTMLInputElement;
    if (prevInput) {
      prevInput.focus();
    }
  }
}

isPINComplete(): boolean {
  return this.EnteredPIN.every(digit => digit !== '' && digit.length === 1);
}

VerifyPINAndResendOrder() {
  // Check if PIN matches
  const enteredPINStr = this.EnteredPIN.join('');
  const generatedPINStr = this.GeneratedPIN.join('');

  if (enteredPINStr !== generatedPINStr) {
    this.PINMismatchError = true;
    // Reset entered PIN
    this.EnteredPIN = ['', '', '', ''];
    return;
  }

  // PIN matches - NULL the UIID and resend the order
  this.PINMismatchError = false;

  // Get cart from localStorage and NULL the UIID
  const cartStr = localStorage.getItem("Cart");
  if (cartStr) {
    const cart = JSON.parse(cartStr);
    cart.UIID = null; // NULL the UIID to allow new order creation
    localStorage.setItem("Cart", JSON.stringify(cart));
  }

  // Also update parent's cart UIID
  if (this.parent.Cart) {
    this.parent.Cart.UIID = null;
  }

  // Determine if it was a PO or RFQ based on DebatorPO BEFORE closing popups (which nulls DuplicateOfferRequest)
  const isPO = this.parent.DuplicateOfferRequest?.DebatorPO && this.parent.DuplicateOfferRequest.DebatorPO.length > 0;

  // Close all popups
  this.CloseResendPINPopup();
  this.CloseDuplicateOrderPopup();

  // Resend the order - call AddNewOffer again with JumpOverDuplicateVerification = true
  this.AddNewOffer(isPO, null, true);
}

SearchIndustryProductB2BOffersExactMatchWithMasterData(searchTerm: string, brandId: number | null = null) {
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    PartnerID: this.parent.B2BPartner?.ID,
    BrandID: brandId,
    SearchTerm: searchTerm,
    Pager: { PageIndex: 1, PageSize: 1 },
    MaxRank: 1,
    Quantity: "1",
    IsAdmin: false,
    B2bAdminSettings: null,
    ApplyClientRestrictions: false,
    IsForPriceRequest: true,
    FinancialStatus: this.parent.B2BPartner?.FinancialData?.Status,
    // ─── Pre-loaded data: eliminates sequential DB fetches per search ───
    PreloadedCurrencies: this.parent.CartMasterData?.Currencies || null,
    PreloadedDecimalPrecisions: this.parent.CartMasterData?.DecimalPrecisions || null,
    PreloadedUserB2BSettings: this.parent.User?.B2BSettings || null,
    PreloadedPartner: this.parent.B2BPartner || null,
    PreloadedIsBlocked: this.parent.B2BPartner?.FinancialData?.Status?.ID === -3 ? true : false,
  };

  this.B2BService.SearchIndustryProductB2BOffersExactMatchWithMasterData(request).subscribe(
    (response: any) => {
      this.LoadingDetectedProduct = false;
      if (response && response.Status === 1 && response.CartItem) {
        this.DetectedProductData = response.CartItem;
        // Ensure Product object exists for editable fields
        if (!this.DetectedProductData.Product) {
          this.DetectedProductData.Product = {
            ID: 0,
            Name: this.DetectedProductUIProductValue || '',
            PartNumber: '',
            Brand: null
          };
        } else if (this.DetectedProductData.Product.ID === 0 || !this.DetectedProductData.Product.Name?.trim()) {
          // If product exists but has no valid ID or Name, use UIProductValue as fallback
          this.DetectedProductData.Product.Name = this.DetectedProductUIProductValue || '';
        }
      } else {
        // Initialize empty structure for editable fields when no product found
        // Use UIProductValue from row as fallback for Product Name
        this.DetectedProductData = {
          Product: {
            ID: 0,
            Name: this.DetectedProductUIProductValue || '',
            PartNumber: '',
            Brand: null
          }
        };
      }
    },
    (error: any) => {
      console.error('Error fetching B2B offers:', error);
      this.LoadingDetectedProduct = false;
      // Initialize empty structure for editable fields on error
      // Use UIProductValue from row as fallback for Product Name
      this.DetectedProductData = {
        Product: {
          ID: 0,
          Name: this.DetectedProductUIProductValue || '',
          PartNumber: '',
          Brand: null
        }
      };
    }
  );
}

AskPriceAndDelivery() {
  // Clear previous error/success state
  this.AskPriceDeliveryError = '';
  this.AskPriceDeliverySuccess = false;
  this.LoadingAskPriceDelivery = true;

  // Build the CartItem from DetectedProductData
  const cartItemToSend = JSON.parse(JSON.stringify(this.DetectedProductData));

  // Ensure Quantity is set (default to 1 if not present)
  if (!cartItemToSend.Quantity || cartItemToSend.Quantity <= 0) {
    cartItemToSend.Quantity = 1;
  }

  // Ensure CartItemOrderInfo exists and populate OrderPartner with B2BPartner
  if (!cartItemToSend.CartItemOrderInfo) {
    cartItemToSend.CartItemOrderInfo = {};
  }
  cartItemToSend.CartItemOrderInfo.OrderPartner = this.parent.B2BPartner;

  // Mandatory: Set Price.UIUnitPrice to null for Ask Price requests
  if (!cartItemToSend.Price) {
    cartItemToSend.Price = {};
  }
  cartItemToSend.Price.UIUnitPrice = null;

  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    CartItem: cartItemToSend
  };

  this.managementService.AddUpdateOfferRequestIndividualItem(request).subscribe(
    (response: any) => {
      this.LoadingAskPriceDelivery = false;
      if (response && response.Status === 1) {
        // Success - show success message in popup
        this.AskPriceDeliverySuccess = true;
        this.AskPriceDeliveryError = '';
      } else {
        // Error from API - show the message
        this.AskPriceDeliveryError = response?.Message || this.translate.instant('AskPriceDeliveryGenericError');
        this.AskPriceDeliverySuccess = false;
      }
    },
    (error: any) => {
      console.error('Error sending price request:', error);
      this.LoadingAskPriceDelivery = false;
      this.AskPriceDeliveryError = this.translate.instant('AskPriceDeliveryGenericError');
      this.AskPriceDeliverySuccess = false;
    }
  );
}

// ✅ Detected Product Popup - Brand Search Methods
InitializeDetectedProductBrandSearch() {
  this.DetectedProductBrandSearchTerm = '';
  this.DetectedProductBrandsList = [];
  this.DetectedProductBrandsLoading = false;
  this.DetectedProductShowBrandDropdown = false;
}

OpenDetectedProductBrandDropdown() {
  this.DetectedProductShowBrandDropdown = true;
  this.DetectedProductBrandSearchTerm = '';
  // Load initial suggestions based on the search term
  this.SearchBrandsForDetectedProductPopup('');
}

CloseDetectedProductBrandDropdown() {
  this.DetectedProductShowBrandDropdown = false;
}

SearchBrandsForDetectedProductPopup(searchTerm: string) {
  const request = {
    User: this.parent.User,
    Language: this.parent.getLanguage(),
    Filter: {
      SearchTerm: searchTerm ?? '',
      Pager: { PageIndex: 1, PageSize: 20 }
    },
    Product: this.DetectedProductSearchTerm ?? null
  };

  this.DetectedProductBrandsLoading = true;

  this.managementService.GetBrandsFilteredWithSuggestion(request).subscribe(
    (response: any) => {
      this.DetectedProductBrandsLoading = false;
      if (response['Status'] === 1) {
        this.DetectedProductBrandsList = response['Brands'] ?? [];
      } else {
        this.DetectedProductBrandsList = [];
      }
    },
    (error: any) => {
      console.error('Error fetching brands:', error);
      this.DetectedProductBrandsLoading = false;
      this.DetectedProductBrandsList = [];
    }
  );
}

SelectDetectedProductBrand(brand: any) {
  // Update the DetectedProductData with the selected brand
  if (this.DetectedProductData) {
    if (!this.DetectedProductData.Product) {
      this.DetectedProductData.Product = {};
    }
    this.DetectedProductData.Product.Brand = brand;
  }
  this.DetectedProductShowBrandDropdown = false;
  this.DetectedProductBrandSearchTerm = '';
}
}
